{
  "about.blocks": "שרתים תחת פיקוח תוכן",
  "about.contact": "יצירת קשר:",
  "about.default_locale": "ברירת המחדל",
  "about.disclaimer": "מסטודון היא תוכנת קוד פתוח חינמית וסימן מסחרי של Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "הסיבה אינה זמינה",
  "about.domain_blocks.preamble": "ככלל מסטודון מאפשרת לך לצפות בתוכן ולתקשר עם משתמשים מכל שרת בפדיברס. אלו הם היוצאים מן הכלל שהוגדרו עבור השרת המסוים הזה.",
  "about.domain_blocks.silenced.explanation": "ככלל פרופילים ותוכן משרת זה לא יוצגו, אלא אם חיפשת אותם באופן מפורש או בחרת להשתתף בו על ידי מעקב.",
  "about.domain_blocks.silenced.title": "מוגבלים",
  "about.domain_blocks.suspended.explanation": "שום מידע משרת זה לא יעובד, יישמר או יוחלף, מה שהופך כל תקשורת עם משתמשים משרת זה לבלתי אפשרית.",
  "about.domain_blocks.suspended.title": "מושעים",
  "about.language_label": "שפה",
  "about.not_available": "המידע אינו זמין על שרת זה.",
  "about.powered_by": "רשת חברתית מבוזרת המופעלת על ידי {mastodon}",
  "about.rules": "כללי השרת",
  "account.account_note_header": "הערה אישית",
  "account.activity": "פעילות",
  "account.add_note": "הוספת הערה פרטית",
  "account.add_or_remove_from_list": "הוספה או הסרה מרשימות",
  "account.badges.admin": "מנהל",
  "account.badges.blocked": "חסום",
  "account.badges.bot": "בוט",
  "account.badges.domain_blocked": "דומיין חסום",
  "account.badges.group": "קבוצה",
  "account.badges.muted": "מושתק",
  "account.badges.muted_until": "מושתק עד {until}",
  "account.block": "חסמי את @{name}",
  "account.block_domain": "חסמו את קהילת {domain}",
  "account.block_short": "לחסום",
  "account.blocked": "חסום",
  "account.cancel_follow_request": "משיכת בקשת מעקב",
  "account.copy": "להעתיק קישור לפרופיל",
  "account.direct": "הודעה פרטית אל @{name}",
  "account.disable_notifications": "הפסק לשלוח לי התראות כש@{name} מפרסמים",
  "account.edit_note": "עריכת הערה פרטית",
  "account.edit_profile": "עריכת פרופיל",
  "account.edit_profile_short": "עריכה",
  "account.enable_notifications": "שלח לי התראות כש@{name} מפרסם",
  "account.endorse": "קדם את החשבון בפרופיל",
  "account.familiar_followers_many": "החשבון נעקב על ידי {name1}, {name2} ועוד {othersCount, plural,one {אחד נוסף שמוכר לך}other {# נוספים שמוכרים לך}}",
  "account.familiar_followers_one": "החשבון נעקב על ידי {name1}",
  "account.familiar_followers_two": "החשבון נעקב על ידי {name1} ו־{name2}",
  "account.featured": "מומלץ",
  "account.featured.accounts": "פרופילים",
  "account.featured.collections": "אוספים",
  "account.featured.new_collection": "אוסף חדש",
  "account.field_overflow": "הצג תוכן מלא",
  "account.filters.all": "כל הפעילות",
  "account.filters.boosts_toggle": "הצגת הדהודים",
  "account.filters.posts_boosts": "הודעות והדהודים",
  "account.filters.posts_only": "הודעות",
  "account.filters.posts_replies": "הודעות ותגובות",
  "account.filters.replies_toggle": "הצגת תגובות",
  "account.follow": "לעקוב",
  "account.follow_back": "לעקוב בחזרה",
  "account.follow_back_short": "לעקוב בחזרה",
  "account.follow_request": "בקשה לעקוב אחרי",
  "account.follow_request_cancel": "ביטול בקשה",
  "account.follow_request_cancel_short": "ביטול",
  "account.follow_request_short": "בקשה",
  "account.followers": "עוקבים",
  "account.followers.empty": "אף אחד לא עוקב אחר המשתמש הזה עדיין.",
  "account.followers_counter": "{count, plural,one {עוקב אחד} other {{counter} עוקבים}}",
  "account.followers_you_know_counter": "{counter} שמוכרים לך",
  "account.following": "נעקבים",
  "account.following_counter": "{count, plural,one {עוקב אחרי {count}}other {עוקב אחרי {counter}}}",
  "account.follows.empty": "משתמש זה עדיין לא עוקב אחרי אף אחד.",
  "account.follows_you": "במעקב אחריך",
  "account.go_to_profile": "מעבר לפרופיל",
  "account.hame.invalid_handle": "שם משתמש לא זמין",
  "account.hide_reblogs": "להסתיר הידהודים מאת @{name}",
  "account.in_memoriam": "פרופיל זכרון.",
  "account.join_modal.day": "יום",
  "account.join_modal.me": "הצטרפת אל {server} בתאריך",
  "account.join_modal.me_anniversary": "פדילדת שמח! הצטרפת אל {server} בתאריך",
  "account.join_modal.me_today": "זהו יומך הראשון על {server}!",
  "account.join_modal.other": "{name} הצטרפו אל {server} בתאריך",
  "account.join_modal.other_today": "זהו היום הראשון של {name} על {server}!",
  "account.join_modal.share.celebrate": "שתפו הודעה לחגיגת האירוע",
  "account.join_modal.share.intro": "שתפו הודעת היכרות",
  "account.join_modal.share.welcome": "שתפו הודעת קבלת פנים",
  "account.join_modal.years": "{number, plural, one {שנה} two {שנתיים} other {# שנים}}",
  "account.joined_short": "תאריך הצטרפות",
  "account.languages": "שנה רישום לשפות",
  "account.last_active": "פעילות אחרונה",
  "account.link_verified_on": "בעלות על הקישור הזה נבדקה לאחרונה ב{date}",
  "account.locked_info": "החשבון הזה הוגדר כנעול. צריך לקבל אישור כדי לעקוב אחריו.",
  "account.media": "מדיה",
  "account.mention": "אזכור של @{name}",
  "account.menu.add_to_collection": "הוספה לאוסף…",
  "account.menu.add_to_list": "הוספה לרשימה…",
  "account.menu.block": "חסימת חשבון",
  "account.menu.block_domain": "חסימת {domain}",
  "account.menu.copied": "קישור לחשבון הועתק לקליפבורד",
  "account.menu.copy": "העתק קישור",
  "account.menu.direct": "אזכור פרטי",
  "account.menu.hide_reblogs": "הסתר הדהודים בקו הזמן",
  "account.menu.mention": "אזכור",
  "account.menu.mute": "השתקת חשבון",
  "account.menu.note.description": "גלוי לך בלבד",
  "account.menu.open_original_page": "לצפות אצל {domain}",
  "account.menu.open_original_page_no_domain": "צפיה על השרת המקורי",
  "account.menu.remove_follower": "הסרת עוקב",
  "account.menu.report": "דווח על חשבון",
  "account.menu.share": "שתף…",
  "account.menu.show_reblogs": "הצג הדהודים בקו הזמן",
  "account.menu.unblock": "הסרת חסימת חשבון",
  "account.menu.unblock_domain": "הסרת חסימה מ־{domain}",
  "account.menu.unmute": "הפסקת השתקת חשבון",
  "account.moved_to": "{name} ציינו שהחשבון החדש שלהם הוא:",
  "account.mute": "להשתיק את @{name}",
  "account.mute_notifications_short": "השתקת התראות",
  "account.mute_short": "השתקה",
  "account.muted": "מושתק",
  "account.mutual": "אתם עוקביםות הדדית",
  "account.name.copy": "העתקת הכינוי",
  "account.name.help.domain": "{domain} הוא השרת שמארח את פרופיל המשתמש(ת) וההודעות שכתב(ה).",
  "account.name.help.domain_self": "{domain} הוא השרת שמארח את פרופיל המשתמש(ת) שלך ואת ההודעות שכתבת.",
  "account.name.help.footer": "באותו האופן שניתן לשלוח דואל לאנשים דרך ספקי דואל שונים, ניתן גם לעקוב ולהחליף מסרים עם אנשים בשרתי מסטודון אחרים, ומשתמשי יישומוני פדיוורס אחרים.",
  "account.name.help.header": "כינוי הוא כמו כתובת דואל",
  "account.name.help.invalid_explanation": "זה יכול לקרות כאשר משתמשת משנה את שם המשתמש שלה, ובדרך כלל מדובר בעניין זמני. אם הבעיה נמשכת, ייתכן שהדבר נובע משרת שאינו זמין או מבעיית הגדרה כלשהי אצלם.",
  "account.name.help.invalid_header": "שם המשתמש כרגע מתעדכן",
  "account.name.help.username": "{username} הוא שם המשתמש של החשבון בשרת שלהם. מישהו משרת אחר יכול להחזיק באותו שם משתמש.",
  "account.name.help.username_self": "{username} הוא שם המשתמש של החשבון שלכם בשרת זה. מישהו משרת אחר יכול להחזיק באותו שם משתמש.",
  "account.name_info": "מה זה אומר?",
  "account.no_bio": "לא סופק תיאור.",
  "account.node_modal.callout": "הערות פרטיות גלויות לך בלבד.",
  "account.node_modal.edit_title": "עריכת הערה פרטית",
  "account.node_modal.error_unknown": "לא ניתן לשמור הערה",
  "account.node_modal.field_label": "הערה פרטית",
  "account.node_modal.save": "שמירה",
  "account.node_modal.title": "הוספת הערה פרטית",
  "account.note.edit_button": "עריכה",
  "account.note.title": "הערה פרטית (זמין רק לך)",
  "account.open_original_page": "לפתיחת העמוד המקורי",
  "account.pending": "בהמתנה",
  "account.posts": "פוסטים",
  "account.remove_from_followers": "הסרת {name} מעוקבי",
  "account.report": "דווח על @{name}",
  "account.requested_follow": "{name} ביקשו לעקוב אחריך",
  "account.share": "שתף את הפרופיל של @{name}",
  "account.show_reblogs": "הצג הדהודים מאת @{name}",
  "account.statuses_counter": "{count, plural, one {הודעה אחת} two {הודעותיים} many {{counter} הודעות} other {{counter} הודעות}}",
  "account.timeline.pinned": "נעוץ",
  "account.timeline.pinned.view_all": "צפיה בכל ההודעות הנעוצות",
  "account.unblock": "להסיר חסימה ל- @{name}",
  "account.unblock_domain": "הסרת החסימה של קהילת {domain}",
  "account.unblock_domain_short": "הסרת חסימה",
  "account.unblock_short": "הסרת חסימה",
  "account.unendorse": "אל תקדם בפרופיל",
  "account.unfollow": "הפסקת מעקב",
  "account.unmute": "הפסקת השתקת @{name}",
  "account.unmute_notifications_short": "הפעלת הודעות",
  "account.unmute_short": "ביטול השתקה",
  "account_edit.advanced_settings.bot_hint": "איתות לאחרים שהחשבון מבצע בעיקר פעולות אוטומטיות ועשוי לא להיות מנוטר",
  "account_edit.advanced_settings.bot_label": "חשבון ממוכן (בוט)",
  "account_edit.advanced_settings.title": "הגדרות מתקדמות",
  "account_edit.bio.add_label": "הוסיפו ביוגרפיה",
  "account_edit.bio.edit_label": "עריכת ביוגרפיה",
  "account_edit.bio.placeholder": "הוסיפו הצגה קצרה כדי לעזור לאחרים לזהות אותך.",
  "account_edit.bio.title": "ביוגרפיה",
  "account_edit.bio_modal.add_title": "הוסיפו ביוגרפיה",
  "account_edit.bio_modal.edit_title": "עריכת ביוגרפיה",
  "account_edit.column_button": "סיום",
  "account_edit.column_title": "עריכת הפרופיל",
  "account_edit.custom_fields.add_label": "הוספת שדה",
  "account_edit.custom_fields.edit_label": "עריכת שדה",
  "account_edit.custom_fields.placeholder": "הוסיפו צורת פניה, קישורים חיצוניים וכל דבר שתרצו לשתף.",
  "account_edit.custom_fields.reorder_button": "הגדרת סדר השדות",
  "account_edit.custom_fields.tip_content": "ניתן להוסיף אמינות לחשבון המסטודון שלך על ידי וידוא קישורים לאתרים שבבעלותך.",
  "account_edit.custom_fields.tip_title": "טיפ: הוספת קישורים מוודאים",
  "account_edit.custom_fields.title": "שדות בהתאמה אישית",
  "account_edit.custom_fields.verified_hint": "כיצד תוסיפו קישורים מוודאים?",
  "account_edit.display_name.add_label": "הוספת שם תצוגה",
  "account_edit.display_name.edit_label": "עריכת שם תצוגה",
  "account_edit.display_name.placeholder": "שם התצוגה שלכן הוא איך שהשם יופיע בפרופיל ובצירי הזמנים.",
  "account_edit.display_name.title": "שם תצוגה",
  "account_edit.featured_hashtags.edit_label": "הוספת תגיות",
  "account_edit.featured_hashtags.placeholder": "עזרו לאחרים לזהות ולגשת בקלות לנושאים החביבים עליכם.",
  "account_edit.featured_hashtags.title": "תגיות נבחרות",
  "account_edit.field_actions.delete": "מחיקת שדה",
  "account_edit.field_actions.edit": "עריכת שדה",
  "account_edit.field_delete_modal.confirm": "האם אתם בטוחיםות שברצונכן למחוק את השדה המיוחד הזה? פעולה זו לא ניתנת לביטול.",
  "account_edit.field_delete_modal.delete_button": "מחק",
  "account_edit.field_delete_modal.title": "מחיקת שדה מתואם אישית?",
  "account_edit.field_edit_modal.add_title": "הוסף שדה מותאם אישית",
  "account_edit.field_edit_modal.discard_confirm": "השלך",
  "account_edit.field_edit_modal.discard_message": "יש שינויים שלא נשמרו. לסלק אותם?",
  "account_edit.field_edit_modal.edit_title": "עריכת שדה מותאם אישית",
  "account_edit.field_edit_modal.length_warning": "עברת את מספר התווים המירבי המומלץ. משתמשים בנייד עלולים שלא לראות את השדה המלא.",
  "account_edit.field_edit_modal.link_emoji_warning": "אנו ממליצים נגד שימוש באמוג'י ייחודיים ביחד עם URL. שדות מיוחדים שמכילים את שניהם יופיעו כמלל בלבד ולא כקישור, כדי למנוע בלבול משתמשים.",
  "account_edit.field_edit_modal.name_hint": "למשל \"אתר אישי\"",
  "account_edit.field_edit_modal.name_label": "תווית",
  "account_edit.field_edit_modal.url_warning": "כדי להוסיף קישור, אנא הכלילו {protocol} בהתחלה.",
  "account_edit.field_edit_modal.value_hint": "למשל “https://example.me”",
  "account_edit.field_edit_modal.value_label": "ערך",
  "account_edit.field_reorder_modal.drag_cancel": "הגרירה בוטלה. השדה \"{item}\" נעזב.",
  "account_edit.field_reorder_modal.drag_end": "השדה \"{item}\" נעזב.",
  "account_edit.field_reorder_modal.drag_instructions": "כדי לארגן מחדש את השדות המיוחדים, לחצו רווח או אנטר. כאשר גוררים, השתמשו במקשי החיצים כדי להזיז שדה מעלה או מטה. לחצו רווח או אנטר בשנית כדי לעזוב את השדה במיקומו החדש, או ESC לביטול.",
  "account_edit.field_reorder_modal.drag_move": "השדה \"{item}\" הוזז.",
  "account_edit.field_reorder_modal.drag_over": "השדה \"{item}\" הוזז על \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "השדה \"{item}\" נבחר.",
  "account_edit.field_reorder_modal.handle_label": "הזזת השדה \"{item}\"",
  "account_edit.field_reorder_modal.title": "סידור שדות",
  "account_edit.image_alt_modal.add_title": "הוספת מלל חלופי",
  "account_edit.image_alt_modal.details_content": "עשו: <ul><li>תארו עצמכם כפי שאתם בצילום</li><li>השתמשו בשפה בגוף שלישי (למשל \"רונית\" במקום \"אני\")</li><li>היו תמציתיים - מילים ספורות יספיקו לרוב</li></ul>אל תעשו: <ul><li>להתחיל תיאור עם \"תמונה של...\" - זה חזרתי מבחינת קוראי מסך</li></ul>דוגמא: <ul><li>\"רונית לבושה בחולצה ירוקה ומרכיבה משקפים\"</li></ul>",
  "account_edit.image_alt_modal.details_title": "עצות: מלל חלופי לתמונות פרופיל",
  "account_edit.image_alt_modal.edit_title": "עריכת מלל חלופי",
  "account_edit.image_alt_modal.text_hint": "מלל חלופי מסייע למשתמשי קוראי מסך להבין את התוכן שלך.",
  "account_edit.image_alt_modal.text_label": "מלל חלופי",
  "account_edit.image_delete_modal.confirm": "האם למחוק את התמונה? לא ניתן לבטל פעולה זו.",
  "account_edit.image_delete_modal.delete_button": "מחיקה",
  "account_edit.image_delete_modal.title": "למחוק תמונה?",
  "account_edit.image_edit.add_button": "הוספת תמונה",
  "account_edit.image_edit.alt_add_button": "הוספת מלל חלופי",
  "account_edit.image_edit.alt_edit_button": "עריכת מלל חלופי",
  "account_edit.image_edit.remove_button": "הסרת תמונה",
  "account_edit.image_edit.replace_button": "החלפת תמונה",
  "account_edit.item_list.delete": "מחיקת {name}",
  "account_edit.item_list.edit": "עריכת {name}",
  "account_edit.name_modal.add_title": "הוספת שם תצוגה",
  "account_edit.name_modal.edit_title": "עריכת שם תצוגה",
  "account_edit.profile_tab.button_label": "התאמה אישית",
  "account_edit.profile_tab.hint.description": "הגדרות אלו משנות מה משתמשים יראו על {server} ביישומונים הרשמיים, אבל הן לא בהכרח רלוונטיות למשתמשים על שרתים אחרים ועל יישומונים צד ג'.",
  "account_edit.profile_tab.hint.title": "התצוגה עשויה להיות שונה",
  "account_edit.profile_tab.show_featured.description": "\"נבחרים\" הוא כרטיסיה לבחירה שבו תוכלו להציג חשבונות אחרים.",
  "account_edit.profile_tab.show_featured.title": "הצגת כרטיסיית \"נבחרים\"",
  "account_edit.profile_tab.show_media.description": "\"מדיה\" הוא כרטיסיה לבחירה שבה יוצגו הודעות שלך שמכילות תמונות או וידאו.",
  "account_edit.profile_tab.show_media.title": "הצגת כרטיסיית \"מדיה\"",
  "account_edit.profile_tab.show_media_replies.description": "כשמאופשר, כרטיסיית המדיה מציגה גם הודעות מקוריות וגם תשובות להודעות של אחרים.",
  "account_edit.profile_tab.show_media_replies.title": "לכלול תגובות בכרטיסיית המדיה",
  "account_edit.profile_tab.show_relations.description": "מראה את העוקבים והנעקבים שלכם בפרופיל. אחרים יוכלו לראות אם אתם עוקבים אחריהם.",
  "account_edit.profile_tab.show_relations.title": "לחשוף עוקבים ונעקבים",
  "account_edit.profile_tab.subtitle": "בחרו בהתאמה אישית איך תרצו שהפרופיל שלכם יוצג.",
  "account_edit.profile_tab.title": "הגדרות הצגת פרופיל",
  "account_edit.save": "שמירה",
  "account_edit.upload_modal.back": "חזרה",
  "account_edit.upload_modal.done": "בוצע",
  "account_edit.upload_modal.next": "הבא",
  "account_edit.upload_modal.step_crop.zoom": "הגדלה",
  "account_edit.upload_modal.step_upload.button": "עיון בקבצים",
  "account_edit.upload_modal.step_upload.dragging": "גרור להעלאה",
  "account_edit.upload_modal.step_upload.header": "בחר/י תמונה",
  "account_edit.upload_modal.step_upload.hint": "תכנים בתקן WEBP, PNG, GIF או JPG, עד לגודל {limit} מ\"ב.{br}התמונה תתוקן לגודל {width} על {height} פיקסלים.",
  "account_edit.upload_modal.title_add.avatar": "הוספת תמונת פרופיל",
  "account_edit.upload_modal.title_add.header": "הוספת תמונת מסגרת",
  "account_edit.upload_modal.title_replace.avatar": "החלפת תמונת פרופיל",
  "account_edit.upload_modal.title_replace.header": "החלפת תמונת מסגרת",
  "account_edit.verified_modal.details": "הוספת אמינות לחשבון המסטודון על ידי הוספת קישורים מוודאים לאתרים אישיים. כך זה עובד:",
  "account_edit.verified_modal.invisible_link.details": "הוסיפו את הקישור בכותרת. החלק החשוב הוא rel=\"me\" שמונע התחזות על אתרים עם תוכן משתמשים. ניתן גם ליצור תגית link בכותרת העמוד במקום קישור {tag} אבל קוד ה־HTML חייב להופיע שם ללא הרצה של ג'אווהסקריפט.",
  "account_edit.verified_modal.invisible_link.summary": "כיצד לגרום לקישור להיות בלתי נראה?",
  "account_edit.verified_modal.step1.header": "העתיקו את קוד HTML שלמטה והדביקו אותו לכותרת האתר שלכם",
  "account_edit.verified_modal.step2.details": "אם כבר הוספתן את אתרכן בשדה המיוחד, תצטרכו למחוק וליצור אותו מחדש כדי לגרום לתהליך הווידוא.",
  "account_edit.verified_modal.step2.header": "הוסיפו את אתרכן בשדה המיוחד",
  "account_edit.verified_modal.title": "כיצד תוסיפו קישורים מוודאים",
  "account_edit_tags.add_tag": "הוספת #{tagName}",
  "account_edit_tags.column_title": "עריכת תגיות",
  "account_edit_tags.help_text": "תגיות נבחרות עוזרות למשתמשים לגלות ולהשתמש בפרופיל שלך. הן יופיעו כסננים במבט הפעילויות על עמוד הפרופיל שלך.",
  "account_edit_tags.max_tags_reached": "הגעת למספר התגיות הנבחרות המירבי.",
  "account_edit_tags.search_placeholder": "הזנת תגית…",
  "account_edit_tags.suggestions": "הצעות:",
  "account_edit_tags.tag_status_count": "{count, plural, one {הודעה אחת} two {הודעותיים} other {# הודעות}}",
  "account_list.hidden_notice": "הרשימה גלויה רק לך. כדי לחשוף אותה לאחרים, יש ללכת אל <link>{page} < {modal} < {field}</link>.",
  "account_list.total": "{total, plural, one {חשבון אחד} other {# חשבונות}}",
  "admin.dashboard.daily_retention": "קצב שימור משתמשים יומי אחרי ההרשמה",
  "admin.dashboard.monthly_retention": "קצב שימור משתמשים (פר חודש) אחרי ההרשמה",
  "admin.dashboard.retention.average": "ממוצע",
  "admin.dashboard.retention.cohort": "חודש רישום",
  "admin.dashboard.retention.cohort_size": "משתמשים חדשים",
  "admin.impact_report.instance_accounts": "פרופילים שימחקו בעקבות כך",
  "admin.impact_report.instance_followers": "עוקבים שהמתשתמשים שלנו יאבדו",
  "admin.impact_report.instance_follows": "עוקבים שהמתשתמשים שלהם יאבדו",
  "admin.impact_report.title": "סיכום ההשפעה",
  "alert.need_reload.message": "מסטודון שודרג. חלק מהדברים עלולים לא לעבוד כראוי עד שתרעננו את הדף.",
  "alert.rate_limited.message": " נא לנסות שוב אחרי {retry_time, time, medium}.",
  "alert.rate_limited.title": "חלה הגבלה על קצב התעבורה",
  "alert.unexpected.message": "אירעה שגיאה בלתי צפויה.",
  "alert.unexpected.title": "אופס!",
  "alt_text_badge.title": "כיתוב חלופי",
  "alt_text_modal.add_alt_text": "הוספת מלל חלופי",
  "alt_text_modal.add_text_from_image": "הוספת מלל מתוך התמונה",
  "alt_text_modal.cancel": "ביטול",
  "alt_text_modal.change_thumbnail": "החלפת התמונה הממוזערת",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "תיאור התוכן לכבדי שמיעה…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "תיאור התוכן לבעלי לקויות ראייה …",
  "alt_text_modal.done": "סיום",
  "announcement.announcement": "הכרזה",
  "annual_report.announcement.action_build": "בנה לי את הסיכומודון שלי",
  "annual_report.announcement.action_dismiss": "לא תודה",
  "annual_report.announcement.action_view": "לצפייה בסיכומודון שלי",
  "annual_report.announcement.description": "ללמוד עוד על דבפוסי השימוש שלך במסטודון לאורך השנה החולפת.",
  "annual_report.announcement.title": "סיכומודון {year} הגיע",
  "annual_report.nav_item.badge": "חדש",
  "annual_report.shared_page.donate": "לתרומה",
  "annual_report.shared_page.footer": "נוצר עם כל ה-{heart} על ידי צוות מסטודון",
  "annual_report.shared_page.footer_server_info": "{username} משתמש.ת ב־{domain}, שרת אחד מבין קהילות רבות שבנויות על מסטודון.",
  "annual_report.summary.archetype.booster.desc_public": "{name} צדו הודעות מעניינות להדהד, והגבירו קולותיהם של יוצרים אחרים בדיוק של חתול המזנק על הטרף.",
  "annual_report.summary.archetype.booster.desc_self": "צדת הודעות מעניינות להדהד, והגברת קולותיהם של יוצרים אחרים בדיוק של חתול המזנק על הטרף.",
  "annual_report.summary.archetype.booster.name": "החתול הצייד",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "למיטב ידיעתנו {name} היו שם, איפשהוא, נהנים ממסטודון בדרכם השקטה.",
  "annual_report.summary.archetype.lurker.desc_self": "למיטב ידיעתנו היית שם, איפשהוא, נהנית ממסטודון בדרכך השקטה.",
  "annual_report.summary.archetype.lurker.name": "הסטואי.ת",
  "annual_report.summary.archetype.oracle.desc_public": "{name} יצרו יותר הודעות מאשר תגובות, ושמרו על מסטודון רעננה ועם פנים לעתיד.",
  "annual_report.summary.archetype.oracle.desc_self": "יצרת יותר הודעות מאשר תגובות, ושמרת על מסטודון רעננה ועם פנים לעתיד.",
  "annual_report.summary.archetype.oracle.name": "כבוד הרב.ה",
  "annual_report.summary.archetype.pollster.desc_public": "{name} יצרו יותר סקרים מאשר כל סוג הודעה אחר, וכך הרבו סקרנות במסטודון.",
  "annual_report.summary.archetype.pollster.desc_self": "יצרת יותר סקרים מאשר כל סוג הודעה אחר, וכך הרבת סקרנות במסטודון.",
  "annual_report.summary.archetype.pollster.name": "התוהה",
  "annual_report.summary.archetype.replier.desc_public": "{name} ענו תכופות לאחרים, והפרו את מסטודון בדיונים חדשים.",
  "annual_report.summary.archetype.replier.desc_self": "ענית תכופות לאחרים, והפרית את מסטודון בדיונים חדשים.",
  "annual_report.summary.archetype.replier.name": "הפרפר",
  "annual_report.summary.archetype.reveal": "גלו את הארכיטיפ שלכם",
  "annual_report.summary.archetype.reveal_description": "תודה שאתם חלק ממסטודון! הגיע הזמן לגלות מה הארכיטיפ שגילמתן בשנת {year}.",
  "annual_report.summary.archetype.title_public": "הארכיטיפ של {name}",
  "annual_report.summary.archetype.title_self": "הארכיטיפ שלך",
  "annual_report.summary.close": "סגירה",
  "annual_report.summary.copy_link": "העתק קישור",
  "annual_report.summary.followers.new_followers": "{count, plural,one {עוקב חדש} other {עוקבים חדשים}}",
  "annual_report.summary.highlighted_post.boost_count": "הודעה זו הודהדה {count, plural,one {פעם אחת}other {# פעמים}}.",
  "annual_report.summary.highlighted_post.favourite_count": "הודעה זו חובבה {count, plural,one {פעם אחת}other {# פעמים}}.",
  "annual_report.summary.highlighted_post.reply_count": "הודעה זו נענתה על ידי {count, plural,one {תגובה אחת}other {# תגובות}}.",
  "annual_report.summary.highlighted_post.title": "ההודעה הפופולרית ביותר",
  "annual_report.summary.most_used_app.most_used_app": "היישומון שהכי בשימוש",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "התג בשימוש הרב ביותר",
  "annual_report.summary.most_used_hashtag.used_count": "כללת את התגית הזו {count, plural,one {בהודעה אחת}other {ב-# הודעות}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} כללו את התגית {count, plural,one {בהודעה אחת}other {ב־# הודעות}}.",
  "annual_report.summary.new_posts.new_posts": "הודעות חדשות",
  "annual_report.summary.percentile.text": "<topLabel>ממקם אותך באחוזון </topLabel><percentage></percentage><bottomLabel>של משמשי {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "לא נגלה לברני.",
  "annual_report.summary.share_elsewhere": "שיתוף במקום אחר",
  "annual_report.summary.share_message": "זוהיתי כדוגמא לטיפוס {archetype}!",
  "annual_report.summary.share_on_mastodon": "לשתף במסטודון",
  "attachments_list.unprocessed": "(לא מעובד)",
  "audio.hide": "השתק",
  "block_modal.no_collections": "שתיכן/שניכם לא יכוליםות להוסיף זו את זה לאוספים. אתן תוסרו אוטומטית מהאוספים האחד של השניה, אם הופעתן בהם.",
  "block_modal.remote_users_caveat": "אנו נבקש מהשרת {domain} לכבד את החלטתך. עם זאת, ציות למוסכמות איננו מובטח כיוון ששרתים מסויימים עשויים לטפל בחסימות בצורה אחרת. הודעות פומביות עדיין יהיו גלויות לעיני משתמשים שאינם מחוברים.",
  "block_modal.show_less": "הצג פחות",
  "block_modal.show_more": "הצג עוד",
  "block_modal.they_cant_mention": "לא תוכלו לאזכר, לעקוב או לצטט האחת את השני.",
  "block_modal.they_cant_see_posts": "הם לא יכולים לראות את תכניכן ואתם לא תוכלו לראות את שלהם.",
  "block_modal.they_will_know": "הם יכולים לראות שהם חסומים.",
  "block_modal.title": "לחסום משתמש?",
  "block_modal.you_wont_see_mentions": "לא תראה הודעות מאחרים שמאזכרות אותם.",
  "boost_modal.combo": "ניתן להקיש {combo} כדי לדלג בפעם הבאה",
  "boost_modal.reblog": "להדהד הודעה?",
  "boost_modal.undo_reblog": "להסיר הדהוד?",
  "bundle_column_error.copy_stacktrace": "העתקת הודעת שגיאה",
  "bundle_column_error.error.body": "הדף המבוקש אינו זמין. זה עשוי להיות באג בקוד או בעייה בתאימות הדפדפן.",
  "bundle_column_error.error.title": "הו, לא!",
  "bundle_column_error.network.body": "קרתה תקלה בעת טעינת העמוד. זו עשויה להיות תקלה זמנית בשרת או בחיבור האינטרנט שלך.",
  "bundle_column_error.network.title": "שגיאת רשת",
  "bundle_column_error.retry": "לנסות שוב",
  "bundle_column_error.return": "חזרה לדף הבית",
  "bundle_column_error.routing.body": "העמוד המבוקש לא נמצא. האם ה־URL נכון?",
  "bundle_column_error.routing.title": "שגיאה 404: הדף לא נמצא",
  "bundle_modal_error.close": "לסגור",
  "bundle_modal_error.message": "משהו השתבש בעת טעינת המסך הזה.",
  "bundle_modal_error.retry": "לנסות שוב",
  "callout.dismiss": "לבטל",
  "carousel.current": "<sr>שקופית</sr>{current, number} מתוך {max, number}",
  "carousel.slide": "שקופית {current, number} מתוך {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} תווים מומלצים",
  "character_counter.required": "{currentLength}/{maxLength} תווים",
  "closed_registrations.other_server_instructions": "מכיוון שמסטודון היא רשת מבוזרת, ניתן ליצור חשבון על שרת נוסף ועדיין לקיים קשר עם משתמשים בשרת זה.",
  "closed_registrations_modal.description": "יצירת חשבון על שרת {domain} איננה אפשרית כרגע, אבל זכרו שאינכן זקוקות לחשבון על {domain} כדי להשתמש במסטודון.",
  "closed_registrations_modal.find_another_server": "חיפוש שרת אחר",
  "closed_registrations_modal.preamble": "מסטודון הוא רשת מבוזרת, כך שלא משנה היכן החשבון שלך, קיימת האפשרות לעקוב ולתקשר עם משתמשים בשרת הזה. אפשר אפילו להריץ שרת בעצמך!",
  "closed_registrations_modal.title": "להרשם למסטודון",
  "collection.share_modal.share_link_label": "שיתוף קישור",
  "collection.share_modal.share_via_post": "לפרסם במסטודון",
  "collection.share_modal.share_via_system": "לשתף אל…",
  "collection.share_modal.title": "שיתוף אוסף",
  "collection.share_modal.title_new": "שתפו את האוסף החדש שלכם!",
  "collection.share_template_other": "הציצו על האוסף המעניין הזה:",
  "collection.share_template_own": "הציצו על האוסף החדש שלי:",
  "collections.account_count": "{count, plural, one {חשבון אחד} other {# חשבונות}}",
  "collections.accounts.empty_description": "להוסיף עד ל־{count} חשבונות",
  "collections.accounts.empty_editor_title": "אוסף זה ריק כרגע",
  "collections.accounts.empty_title": "האוסף הזה ריק",
  "collections.add_to_collection": "להוסיף את {name} לאוספים",
  "collections.block_collection_owner": "חסימת חשבון",
  "collections.by_account": "מאת {account_handle}",
  "collections.collection_description": "תיאור",
  "collections.collection_language": "שפה",
  "collections.collection_language_none": "לא מצוין",
  "collections.collection_name": "כינוי",
  "collections.collection_topic": "נושא",
  "collections.confirm_account_removal": "בוודאות להסיר חשבון זה מהאוסף?",
  "collections.content_warning": "אזהרת תוכן",
  "collections.continue": "המשך",
  "collections.copy_link": "להעתקת הקישור",
  "collections.copy_link_confirmation": "קישור לחשבון הועתק לקליפבורד",
  "collections.create.accounts_title": "את מי תבליטו באוסף זה?",
  "collections.create.basic_details_title": "פרטים בסיסיים",
  "collections.create.steps": "צעד {step} מתוך {total}",
  "collections.create_collection": "יצירת אוסף",
  "collections.create_new_collection": "יצירת אוסף חדש",
  "collections.delete_collection": "מחיקת האוסף",
  "collections.description_length_hint": "מגבלה של 100 תווים",
  "collections.detail.author_added_you_on_date": "{author} הוסיפו אותך בתאריך {date}",
  "collections.detail.loading": "טוען אוסף…",
  "collections.detail.revoke_inclusion": "הסירוני",
  "collections.detail.sensitive_content": "תוכן רגיש",
  "collections.detail.sensitive_note": "התיאור והחשבונות עשויים שלא להתאים לכל הצופיםות.",
  "collections.detail.share": "שיתוף אוסף",
  "collections.detail.you_are_in_this_collection": "אתם מופיעים באוסף זה",
  "collections.edit_details": "עריכת פרטים",
  "collections.error_loading_collections": "חלה שגיאה בנסיון לטעון אוספים אלו.",
  "collections.hidden_accounts_description": "חסמת או השתקת {count, plural,one {המשתמש.ת}other {המשתמשים}} האלו",
  "collections.hidden_accounts_link": "{count, plural, one {חשבון מוסתר אחד} other {# חשבונות מוסתרים}}",
  "collections.hints.accounts_counter": "{count} \\ {max} חשבונות",
  "collections.last_updated_at": "עדכון אחרון: {date}",
  "collections.list.collections_with_count": "{count, plural, one {אוסף אחד} other {# אוספים}}",
  "collections.list.created_by_author": "נוצר בידי {name}",
  "collections.list.created_by_you": "נוצר על ידיך",
  "collections.list.featuring_you": "כולל אותך",
  "collections.manage_accounts": "ניהול חשבונות",
  "collections.mark_as_sensitive": "מסומנים כרגישים",
  "collections.mark_as_sensitive_hint": "הסתרת תיאור וחשבונות האוסף מאחורי אזהרת תוכן. שם האוסף עדיין ישאר גלוי.",
  "collections.maximum_collection_count_description": "השרת שלך מגביל יצירה של עד {count} אוספים.",
  "collections.maximum_collection_count_reached": "יצרת את מספר האוספים המירבי",
  "collections.name_length_hint": "מגבלה של 40 תווים",
  "collections.new_collection": "אוסף חדש",
  "collections.pending_accounts.message": "חשבונות יסומנו כממתינים כאשר מחכים לתגובה מהמשתמשים בשרת שלהם. רק אתם יכולים לראות חשבונות בהמתנה לאישור.",
  "collections.pending_accounts.title": "מדוע אני רואה חשבונות ממתינים לאישור?",
  "collections.remove_account": "הסרה",
  "collections.report_collection": "דיווח על אוסף זה",
  "collections.revoke_collection_inclusion": "הסירוני מאוסף זה",
  "collections.revoke_inclusion.confirmation": "הוסרת מֿ\"{collection}\"",
  "collections.revoke_inclusion.error": "הייתה שגיאה. נסו שוב מאוחר יותר.",
  "collections.search_accounts_label": "לחפש חשבון להוספה",
  "collections.search_accounts_max_reached": "הגעת למספר החשבונות המירבי",
  "collections.sensitive": "רגיש",
  "collections.share_short": "שיתוף",
  "collections.sort_alphabetical": "בסדר האלפבית",
  "collections.sort_by": "מיין לפי:",
  "collections.sort_date_added": "תאריך הוספה",
  "collections.sort_last_active": "פעילות אחרונה",
  "collections.sort_most_followers": "מירב העוקבים",
  "collections.suggestions.can_not_add": "לא ניתן להוסיף",
  "collections.suggestions.can_not_add_desc": "חשבונות אלו כנראה ביקשו לא להכלל ב\"תגליות\" או שהם משתמשים בשרת שאינו תומך באוספים.",
  "collections.suggestions.must_follow": "יש לעקוב תחילה",
  "collections.suggestions.must_follow_desc": "חשבונות אלו בחרו לברור בקשות מעקב. עוקבים יכולים להוסיף אותם לאוספים.",
  "collections.topic_hint": "הוספת תגית שמסייעת לאחרים להבין את הנושא הראשי של האוסף.",
  "collections.topic_special_chars_hint": "תווים מיוחדים יוסרו בעת השמירה",
  "collections.unlisted_collections_description": "אוספים אלו לא מוצגים לאחרים בפרופיל שלך. למי שיקבל את הקישור תהיה גישה לגלות את התכנים.",
  "collections.unlisted_collections_with_count": "אוספים שאינם לתצוגה ({count})",
  "collections.view_collection": "צפיה באוסף",
  "collections.visibility_public": "פומבי",
  "collections.visibility_public_hint": "זמין לגילוי בתוצאות חיפוש ושאר אזורים בהם מופיעות המלצות.",
  "collections.visibility_title": "ניראות",
  "collections.visibility_unlisted": "מוסתר",
  "collections.visibility_unlisted_hint": "זמין לכל מי שקיבל קישור. נסתר מתוצאות חיפוש והמלצות.",
  "column.about": "אודות",
  "column.blocks": "משתמשים חסומים",
  "column.bookmarks": "סימניות",
  "column.community": "פיד שרת מקומי",
  "column.create_list": "יצירת רשימה",
  "column.direct": "הודעות פרטיות",
  "column.directory": "עיין בפרופילים",
  "column.domain_blocks": "קהילות (שמות מתחם) מוסתרות",
  "column.edit_list": "עריכת רשימה",
  "column.favourites": "חיבובים",
  "column.firehose": "פידים עדכניים",
  "column.firehose_local": "פיד זמן האמת עבור שרת זה",
  "column.firehose_singular": "פיד זמן אמת",
  "column.follow_requests": "בקשות מעקב",
  "column.home": "פיד הבית",
  "column.list_members": "ניהול חברי הרשימה",
  "column.lists": "רשימות",
  "column.mutes": "משתמשים בהשתקה",
  "column.notifications": "התראות",
  "column.other_collections": "אוספים מאת {name}",
  "column.pins": "חיצרוצים נעוצים",
  "column.public": "פיד כללי (כל השרתים)",
  "column.your_collections": "האוספים שלך",
  "column_back_button.label": "בחזרה",
  "column_header.hide_settings": "הסתרת הגדרות",
  "column_header.moveLeft_settings": "הזזת טור לשמאל",
  "column_header.moveRight_settings": "הזזת טור לימין",
  "column_header.pin": "הצמדה",
  "column_header.show_settings": "הצגת העדפות",
  "column_header.unpin": "שחרור הצמדה",
  "column_search.cancel": "ביטול",
  "combobox.close_results": "סגירת תוצאות",
  "combobox.loading": "בטעינה",
  "combobox.no_results_found": "אין תוצאות עבור החיפוש הזה",
  "combobox.open_results": "ראו תוצאות",
  "combobox.results_available": "{count, plural,one {הצעה אחת זמינה} other {# הצעות זמינות} two {הצעותיים זמינות}}. השתמשו בחיצים מעלה ומטה בכדי לנווט, מקש Enter כדי לבחור.",
  "community.column_settings.local_only": "מקומי בלבד",
  "community.column_settings.media_only": "מדיה בלבד",
  "community.column_settings.remote_only": "מרוחק בלבד",
  "compose.error.blank_post": "הודעה לא יכולה להיות ריקה.",
  "compose.language.change": "שינוי שפת ההודעה",
  "compose.language.search": "חיפוש שפות...",
  "compose.published.body": "הודעה פורסמה.",
  "compose.published.open": "פתיחה",
  "compose.saved.body": "ההודעה נשמרה.",
  "compose_form.direct_message_warning_learn_more": "מידע נוסף",
  "compose_form.encryption_warning": "הודעות במסטודון לא מוצפנות מקצה לקצה. אל תשתפו מידע רגיש במסטודון.",
  "compose_form.hashtag_warning": "הודעה זו לא תרשם תחת תגיות הקבצה היות והנראות שלה איננה 'ציבורית'. רק הודעות ציבוריות ימצאו בחיפוש תגיות הקבצה.",
  "compose_form.lock_disclaimer": "חשבונך אינו {locked}. כל אחד יוכל לעקוב אחריך כדי לקרוא את הודעותיך המיועדות לעוקבים בלבד.",
  "compose_form.lock_disclaimer.lock": "נעול",
  "compose_form.placeholder": "על מה את.ה חושב.ת?",
  "compose_form.poll.duration": "משך הסקר",
  "compose_form.poll.multiple": "בחירה מרובה",
  "compose_form.poll.option_placeholder": "אפשרות {number}",
  "compose_form.poll.single": "בחירה יחידה",
  "compose_form.poll.switch_to_multiple": "אפשרו בחירה מרובה בסקר",
  "compose_form.poll.switch_to_single": "אפשרו בחירה בודדת בסקר",
  "compose_form.poll.type": "סוג משאל",
  "compose_form.publish": "הודעה",
  "compose_form.reply": "תגובה",
  "compose_form.save_changes": "עדכון",
  "compose_form.spoiler.marked": "הסר אזהרת תוכן",
  "compose_form.spoiler.unmarked": "הוסף אזהרת תוכן",
  "compose_form.spoiler_placeholder": "אזהרת תוכן (לא חובה)",
  "confirmation_modal.cancel": "ביטול",
  "confirmations.block.confirm": "לחסום",
  "confirmations.delete.confirm": "למחוק",
  "confirmations.delete.message": "בטוח/ה שאת/ה רוצה למחוק את ההודעה?",
  "confirmations.delete.title": "למחוק הודעה?",
  "confirmations.delete_collection.confirm": "מחק",
  "confirmations.delete_collection.message": "פעולה זו אינה הפיכה.",
  "confirmations.delete_collection.title": "למחוק את \"{name}\"?",
  "confirmations.delete_list.confirm": "למחוק",
  "confirmations.delete_list.message": "האם אתם בטוחים שאתם רוצים למחוק את הרשימה לצמיתות?",
  "confirmations.delete_list.title": "למחוק רשימה?",
  "confirmations.discard_draft.confirm": "לאפס ולהמשיך",
  "confirmations.discard_draft.edit.cancel": "חזרה לעריכה",
  "confirmations.discard_draft.edit.message": "מעבר הלאה יאפס את כל השינויים שביצעת להודעה שכרגע ערכת.",
  "confirmations.discard_draft.edit.title": "לאפס את השינויים להודעתך?",
  "confirmations.discard_draft.post.cancel": "חזרה לעריכת טיוטא",
  "confirmations.discard_draft.post.message": "מעבר הלאה ימחק את ההודעה שכרגע חיברת.",
  "confirmations.discard_draft.post.title": "לוותר על הטיוטא?",
  "confirmations.discard_edit_media.confirm": "השלך",
  "confirmations.discard_edit_media.message": "יש לך שינויים לא שמורים לתיאור המדיה. להשליך אותם בכל זאת?",
  "confirmations.follow_to_list.confirm": "עקיבה והוספה לרשימה",
  "confirmations.follow_to_list.message": "כדי להכניס את {name} לרשימה, ראשית יש לעקוב אחריהם.",
  "confirmations.follow_to_list.title": "לעקוב אחר המשתמש.ת?",
  "confirmations.hide_featured_tab.confirm": "הסתר כרטיסייה",
  "confirmations.hide_featured_tab.intro": "ניתן לשנות זאת בכל עת תחת <i>עריכת פרופיל > העדפות כרטיסיית פרופיל</i>.",
  "confirmations.hide_featured_tab.message": "הסתרת הכרטיסיה מפני המשתמשים.ות על {serverName} ושרתים אחרים המריצים גרסא עדכנית של מסטודון. ההצגה באתרים אחרים עלולה להיות שונה.",
  "confirmations.hide_featured_tab.title": "להסתיר כרטיסיית \"נבחרים\"?",
  "confirmations.logout.confirm": "התנתקות",
  "confirmations.logout.message": "האם אתם בטוחים שאתם רוצים להתנתק?",
  "confirmations.logout.title": "להתנתק?",
  "confirmations.missing_alt_text.confirm": "הוספת מלל חלופי",
  "confirmations.missing_alt_text.message": "ההודעה שלך כוללת קבצים גרפיים ללא תיאור (מלל חלופי). הוספת תיאורים עוזרת להנגיש את התוכן ליותר אנשים.",
  "confirmations.missing_alt_text.secondary": "לפרסם בכל זאת",
  "confirmations.missing_alt_text.title": "להוסיף מלל חלופי?",
  "confirmations.mute.confirm": "להשתיק",
  "confirmations.private_quote_notify.cancel": "חזרה לעריכה",
  "confirmations.private_quote_notify.confirm": "פרסום ההודעה",
  "confirmations.private_quote_notify.do_not_show_again": "אל תראה לי הודעה זו שוב",
  "confirmations.private_quote_notify.message": "המצוטט ומאוזכרים אחרים יקבלו התראה ויוכלו לקרוא את ההודעה שלך, אפילו אם אינם עוקבים אחריך.",
  "confirmations.private_quote_notify.title": "לשתף עם עוקבים ומאוזכרים?",
  "confirmations.quiet_post_quote_info.dismiss": "אל תזכיר לי שוב",
  "confirmations.quiet_post_quote_info.got_it": "הבנתי",
  "confirmations.quiet_post_quote_info.message": "כשמצטטים הודעה ציבורית שקטה, גם ההודעה המצטטת תוסתר מחלון הנושאים החמים.",
  "confirmations.quiet_post_quote_info.title": "ציטוט הודעות ציבוריות שקטות",
  "confirmations.redraft.confirm": "מחיקה ועריכה מחדש",
  "confirmations.redraft.message": "למחוק ולהתחיל טיוטה חדשה? חיבובים והדהודים יאבדו, ותגובות להודעה המקורית ישארו יתומות.",
  "confirmations.redraft.title": "מחיקה ועריכה מחדש?",
  "confirmations.remove_from_followers.confirm": "הסרת עוקב",
  "confirmations.remove_from_followers.message": "{name} יוסר/תוסר ממעקב אחריך. האם להמשיך?",
  "confirmations.remove_from_followers.title": "להסיר עוקב/עוקבת?",
  "confirmations.revoke_collection_inclusion.confirm": "הסירוני",
  "confirmations.revoke_collection_inclusion.message": "אוצרי האוסף לא יוכלו להוסיפך חזרה לאוסף זה למשך 24 שעות. כדי למנוע מהם להוסיפך לאוספים באופן קבוע, ניתן לחסום אותם.",
  "confirmations.revoke_collection_inclusion.title": "להסירך מאוסף זה?",
  "confirmations.revoke_quote.confirm": "הסרת הודעה",
  "confirmations.revoke_quote.message": "פעולה זו אינה הפיכה.",
  "confirmations.revoke_quote.title": "הסרת הודעה?",
  "confirmations.unblock.confirm": "הסרת חסימה",
  "confirmations.unblock.title": "הסרת חסימה מ־{name}?",
  "confirmations.unfollow.confirm": "הפסקת מעקב",
  "confirmations.unfollow.title": "בטול מעקב אחרי {name}?",
  "confirmations.withdraw_request.confirm": "משיכת בקשה",
  "confirmations.withdraw_request.title": "משיכת בקשת מעקב אחרי {name}?",
  "content_warning.hide": "הסתרת חיצרוץ",
  "content_warning.show": "להציג בכל זאת",
  "content_warning.show_more": "הצג עוד",
  "content_warning.show_short": "הצג",
  "conversation.delete": "מחיקת שיחה",
  "conversation.mark_as_read": "סמן כנקרא",
  "conversation.open": "צפו בשיחה",
  "conversation.with": "עם {names}",
  "copy_icon_button.copied": "הועתק ללוח",
  "copy_icon_button.copy_this_text": "העתקת הקישור",
  "copypaste.copied": "הועתק",
  "copypaste.copy_to_clipboard": "העתקה ללוח הגזירים",
  "custom_homepage.about": "אודות",
  "custom_homepage.about_this_server": "אודות שרת זה",
  "custom_homepage.administered_by": "מנוהל ע\"י",
  "custom_homepage.contact": "יצירת קשר:",
  "custom_homepage.latest_activity": "הפעילות האחרונה",
  "custom_homepage.these_are_the_latest_posts": "הנה 40 הפרסומים האחרונים מחשבונות שעל שרת זה.",
  "directory.federated": "מהפדרציה הידועה",
  "directory.local": "מ- {domain} בלבד",
  "directory.new_arrivals": "חדשים כאן",
  "directory.recently_active": "פעילים לאחרונה",
  "disabled_account_banner.account_settings": "הגדרות חשבון",
  "disabled_account_banner.text": "חשבונך {disabledAccount} אינו פעיל כרגע.",
  "dismissable_banner.community_timeline": "אלו הם החצרוצים הציבוריים האחרונים מהמשתמשים על שרת {domain}.",
  "dismissable_banner.dismiss": "בטל",
  "dismissable_banner.public_timeline": "אלו ההודעות האחרונות שהתקבלו מהמשתמשיםות ברשת המבוזרת, אשר משתמשיםות ב־{domain} עוקביםות אחריהםן.",
  "domain_block_modal.block": "חסימת שרת",
  "domain_block_modal.block_account_instead": "לחסום את @{name} במקום שרת שלם",
  "domain_block_modal.they_can_interact_with_old_posts": "משתמשים משרת זה יכולים להתייחס להודעותיך הישנות.",
  "domain_block_modal.they_cant_follow": "משתמש משרת זה לא יכול לעקוב אחריך.",
  "domain_block_modal.they_wont_know": "הם לא ידעו כי נחסמו.",
  "domain_block_modal.title": "לחסום שרת?",
  "domain_block_modal.you_will_lose_num_followers": "{followersCount, plural,one {יאבד לך עוקב אחד}other {יאבדו לך {followersCountDisplay} עוקבים}} {followingCount, plural,one  {ונעקב אחד}other {ו־{followingCountDisplay} נעקבים}}.",
  "domain_block_modal.you_will_lose_relationships": "יאבדו לך כל העוקבים והנעקבים משרת זה.",
  "domain_block_modal.you_wont_see_posts": "לא תוכלו לראות הודעות ממשתמשים על שרת זה.",
  "dropdown.empty": "בחירת אפשרות",
  "email_subscriptions.email": "דוא״ל",
  "email_subscriptions.form.action": "הרשמה",
  "email_subscriptions.form.bottom": "קבלו הודעות לתיבת הדואל מבלי ליצור חשבון מסטודון. ניתן לבטל בכל עת. למידע נוסף, קראו <a>במדיניות הפרטיות</a>.",
  "email_subscriptions.form.title": "הרשמה לקבלת עידכוני דואל מאת {name}",
  "email_subscriptions.submitted.lead": "יש לחפש בתיבת הדואל הודעה לסיום ההרשמה לעידכונים בדואל.",
  "email_subscriptions.submitted.title": "עוד שלב אחד אחרון",
  "email_subscriptions.validation.email.blocked": "ספק דואל חסום",
  "email_subscriptions.validation.email.invalid": "כתובת דוא״ל לא תקינה",
  "embed.instructions": "ניתן להטמיע את ההודעה הזו באתרך ע\"י העתקת הקוד שלהלן.",
  "embed.preview": "דוגמא כיצד זה יראה:",
  "emoji_button.activity": "פעילות",
  "emoji_button.clear": "ניקוי",
  "emoji_button.custom": "בהתאמה אישית",
  "emoji_button.flags": "דגלים",
  "emoji_button.food": "אוכל ושתיה",
  "emoji_button.label": "הוספת אמוג'י",
  "emoji_button.nature": "טבע",
  "emoji_button.not_found": "לא נמצאו סמלונים מתאימים",
  "emoji_button.objects": "אובייקטים",
  "emoji_button.people": "אנשים",
  "emoji_button.recent": "בשימוש תדיר",
  "emoji_button.search": "חיפוש...",
  "emoji_button.search_results": "תוצאות חיפוש",
  "emoji_button.symbols": "סמלים",
  "emoji_button.travel": "טיולים ואתרים",
  "empty_column.account_featured.other": "{acct} עוד לא קידם תכנים.",
  "empty_column.account_featured_self.no_collections_button": "יצירת אוסף",
  "empty_column.account_featured_self.no_collections_hide_tab": "הסתרת הכרטיסיה במקום הצגתה ריקה",
  "empty_column.account_featured_self.showcase_accounts": "הצגת החשבונות החביבים עליך",
  "empty_column.account_featured_self.showcase_accounts_desc": "אוספים הם רשימות חשבונות שאתם אוצרים כדי לעזור לאחרים לגלות עוד תכנים בפדיוורס.",
  "empty_column.account_featured_unknown.other": "חשבון זה עוד לא קידם תכנים.",
  "empty_column.account_hides_collections": "המשתמש.ת בחר.ה להסתיר מידע זה",
  "empty_column.account_suspended": "חשבון מושעה",
  "empty_column.account_timeline": "אין עדיין אף הודעה!",
  "empty_column.account_unavailable": "פרופיל לא זמין",
  "empty_column.blocks": "עדיין לא חסמתם משתמשים אחרים.",
  "empty_column.bookmarked_statuses": "אין עדיין הודעות שחיבבת. כשתחבב את הראשונה, היא תופיע כאן.",
  "empty_column.collections": "{acct} עוד לא יצרו אוספים.",
  "empty_column.collections.featured_in": "עוד לא הוסיפו אותך לאף אוסף.",
  "empty_column.collections.featured_in_undiscoverable": "כדי שאחרים יוכלו להוסיפך לאוספים, עליך לאפשר להופיע ב\"תגליות\" תחת <link>העדפות > פרטיות ומידת חשיפה</link>",
  "empty_column.collections_self": "עוד לא יצרת אוספים.",
  "empty_column.community": "פיד השרת המקומי ריק. יש לפרסם משהו כדי שדברים יתרחילו להתגלגל!",
  "empty_column.direct": "אין לך שום הודעות פרטיות עדיין. כשתשלחו או תקבלו אחת, היא תופיע כאן.",
  "empty_column.disabled_feed": "פיד זה נחסם לשימוש על ידי מנהלי השרת שלך.",
  "empty_column.domain_blocks": "אין עדיין קהילות מוסתרות.",
  "empty_column.explore_statuses": "אין נושאים חמים כרגע. אולי אחר כך!",
  "empty_column.favourited_statuses": "אין עדיין הודעות שחיבבת. כשתחבב/י את הראשונה, היא תופיע כאן.",
  "empty_column.favourites": "עוד לא חיבבו את ההודעה הזו. כאשר זה יקרה, החיבובים יופיעו כאן.",
  "empty_column.follow_requests": "אין לך שום בקשות מעקב עדיין. לכשיתקבלו כאלה, הן תופענה כאן.",
  "empty_column.followed_tags": "עוד לא עקבת אחרי תגיות. כשיהיו לך תגיות נעקבות, ההודעות יופיעו פה.",
  "empty_column.hashtag": "אין כלום בתגית הזאת עדיין.",
  "empty_column.home": "פיד הבית ריק ! אפשר לבקר ב{public} או להשתמש בחיפוש כדי להתחיל ולהכיר משתמשים/ות אחרים/ות. {suggestions}",
  "empty_column.list": "אין עדיין פריטים ברשימה. כאשר חברים ברשימה הזאת יפרסמו הודעות חדשות, הן יופיעו פה.",
  "empty_column.mutes": "עוד לא השתקת שום משתמש.",
  "empty_column.notification_requests": "בום! אין פה כלום. כשיווצרו עוד התראות, הן יופיעו כאן על בסיס ההעדפות שלך.",
  "empty_column.notifications": "אין התראות עדיין. יאללה, הגיע הזמן להתחיל להתערבב.",
  "empty_column.public": "אין פה כלום! כדי למלא את הטור הזה אפשר לכתוב משהו, או להתחיל לעקוב אחרי אנשים מקהילות אחרות",
  "empty_state.no_results": "אין תוצאות",
  "error.no_hashtag_feed_access": "הצטרפו או התחברו כדי לעקוב אחרי תגית זו.",
  "error.unexpected_crash.explanation": "עקב תקלה בקוד שלנו או בעיית תאימות דפדפן, לא ניתן להציג דף זה כראוי.",
  "error.unexpected_crash.explanation_addons": "לא ניתן להציג דף זה כראוי. הבעיה נגרמת כנראה עקב תוסף דפדפן או כלי תרגום אוטומטי.",
  "error.unexpected_crash.next_steps": "נסה/י לרענן את הדף. אם זה לא עוזר, אולי אפשר עדיין להשתמש במסטודון דרך דפדפן אחר או באמצעות אפליקציה ילידית.",
  "error.unexpected_crash.next_steps_addons": "נסה/י להסיר אותם ולרענן את הדף. אם זה לא עוזר, אולי אפשר עדיין להשתמש במסטודון דרך דפדפן אחר או באמצעות אפליקציה ילידית.",
  "errors.unexpected_crash.copy_stacktrace": "להעתיק את הקוד ללוח הכתיבה",
  "errors.unexpected_crash.report_issue": "דווח על בעיה",
  "explore.suggested_follows": "אנשים",
  "explore.title": "מגמות",
  "explore.trending_links": "חדשות",
  "explore.trending_statuses": "הודעות",
  "explore.trending_tags": "תגיות",
  "featured_carousel.current": "<sr>הודעה</sr>{current, number} מתוך {max, number}",
  "featured_carousel.header": "{count, plural, one {הודעה אחת נעוצה} two {הודעותיים נעוצות} many {הודעות נעוצות} other {הודעות נעוצות}}",
  "featured_carousel.slide": "הודעה {current, number} מתוך {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "לאחרונה פרסמת על {items}. להוסיף את הנושאים לתגיות הנבחרות?",
  "featured_tags.suggestions.add": "הוספה",
  "featured_tags.suggestions.added": "ניהול התגיות הנבחרות בכל עת תחת <link>עריכת פרופיל > תגיות נבחרות</link>.",
  "featured_tags.suggestions.dismiss": "לא תודה",
  "filter_modal.added.context_mismatch_explanation": "קטגוריית הסנן הזאת לא חלה על ההקשר שממנו הגעת אל ההודעה הזו. אם תרצה/י שההודעה תסונן גם בהקשר זה, תצטרך/י לערוך את הסנן.",
  "filter_modal.added.context_mismatch_title": "אין התאמה להקשר!",
  "filter_modal.added.expired_explanation": "פג תוקפה של קטגוריית הסינון הזו, יש צורך לשנות את תאריך התפוגה כדי שהסינון יוחל.",
  "filter_modal.added.expired_title": "פג תוקף הסנן!",
  "filter_modal.added.review_and_configure": "לסקירה והתאמה מתקדמת של קטגוריית הסינון הזו, לכו ל{settings_link}.",
  "filter_modal.added.review_and_configure_title": "אפשרויות סינון",
  "filter_modal.added.settings_link": "דף הגדרות",
  "filter_modal.added.short_explanation": "ההודעה הזו הוספה לקטגוריית הסינון הזו: {title}.",
  "filter_modal.added.title": "הסנן הוסף!",
  "filter_modal.select_filter.context_mismatch": "לא חל בהקשר זה",
  "filter_modal.select_filter.expired": "פג התוקף",
  "filter_modal.select_filter.prompt_new": "קטגוריה חדשה {name}",
  "filter_modal.select_filter.search": "חיפוש או יצירה",
  "filter_modal.select_filter.subtitle": "שימוש בקטגורייה קיימת או יצירת אחת חדשה",
  "filter_modal.select_filter.title": "סינון ההודעה הזו",
  "filter_modal.title.status": "סנן הודעה",
  "filter_warning.matches_filter": "תואם לסנן “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "{count, plural,=0 {אין בקשות ממשתמשים }one {בקשה אחת ממישהו/מישהי }two {יש בקשותיים ממשתמשים }other {יש # בקשות ממשתמשים }}שאולי מוכרים לך",
  "filtered_notifications_banner.title": "התראות מסוננות",
  "firehose.all": "הכל",
  "firehose.local": "שרת זה",
  "firehose.remote": "שרתים אחרים",
  "follow_request.authorize": "הרשאה",
  "follow_request.reject": "דחיה",
  "follow_requests.unlocked_explanation": "למרות שחשבונך אינו נעול, צוות {domain} חושב שאולי כדאי לוודא את בקשות המעקב האלה ידנית.",
  "follow_suggestions.curated_suggestion": "בחירת הצוות",
  "follow_suggestions.dismiss": "לא להציג שוב",
  "follow_suggestions.featured_longer": "נבחר ידנית על ידי הצוות של {domain}",
  "follow_suggestions.friends_of_friends_longer": "פופולרי בין הנעקבים שלך",
  "follow_suggestions.hints.featured": "החשבון הזה נבחר אישית על ידי צוות {domain}.",
  "follow_suggestions.hints.friends_of_friends": "חשבון זה פופולרי בין הנעקבים שלך.",
  "follow_suggestions.hints.most_followed": "חשבון זה הוא מבין הנעקבים ביותר בשרת {domain}.",
  "follow_suggestions.hints.most_interactions": "חשבון זה קיבל לאחרונה הרבה תשומת לב על שרת {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "חשבון זה דומה לחשבונות אחרים שאחריהם התחלת לעקוב לאחרונה.",
  "follow_suggestions.personalized_suggestion": "הצעות מותאמות אישית",
  "follow_suggestions.popular_suggestion": "הצעה פופולרית",
  "follow_suggestions.popular_suggestion_longer": "פופולרי בקהילת {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "דומה למשתמשות.ים שעקבת אחריהן.ם לאחרונה",
  "follow_suggestions.view_all": "צפיה בכל",
  "follow_suggestions.who_to_follow": "אחרי מי לעקוב",
  "followed_tags": "התגיות שהחשבון שלך עוקב אחריהן",
  "followers.hide_other_followers": "משתשמש‎‏(ת) אלו החליטו לא לחשוף את עוקביהם האחרים",
  "followers.title": "עוקבים אחרי {name}",
  "following.hide_other_following": "משתשמש‎‏(ת) אלו החליטו לא לחשוף את נעקביהם האחרים",
  "following.title": "נעקבים על ידי {name}",
  "footer.about": "אודות",
  "footer.about_mastodon": "אודות מסטודון",
  "footer.about_server": "‮אודות ‭{domain}",
  "footer.about_this_server": "אודות",
  "footer.directory": "ספריית פרופילים",
  "footer.get_app": "להתקנת היישומון",
  "footer.keyboard_shortcuts": "קיצורי מקלדת",
  "footer.privacy_policy": "מדיניות פרטיות",
  "footer.source_code": "צפיה בקוד המקור",
  "footer.status": "מצב",
  "footer.terms_of_service": "תנאי השירות",
  "form_error.blank": "שדות לא יכולים להשאר ריקים.",
  "form_field.optional": "(אפשרות)",
  "getting_started.heading": "בואו נתחיל",
  "hashtag.admin_moderation": "פתיחת ממשק פיקוח דיון עבור #{name}",
  "hashtag.browse": "קריאת הודעות תחת #{hashtag}",
  "hashtag.browse_from_account": "קריאת הודעות מאת @{name} תחת #{hashtag}",
  "hashtag.column_header.tag_mode.all": "ו- {additional}",
  "hashtag.column_header.tag_mode.any": "או {additional}",
  "hashtag.column_header.tag_mode.none": "ללא {additional}",
  "hashtag.column_settings.select.no_options_message": "לא נמצאו הצעות",
  "hashtag.column_settings.select.placeholder": "הזן תגי הקבצה…",
  "hashtag.column_settings.tag_mode.all": "כל אלה",
  "hashtag.column_settings.tag_mode.any": "לפחות אחד מאלה",
  "hashtag.column_settings.tag_mode.none": "אף אחד מאלה",
  "hashtag.column_settings.tag_toggle": "כלול תגיות נוספות בטור זה",
  "hashtag.counter_by_accounts": "{count, plural,one{{count} משתתף.ת}other{{counter} משתתפיםות}}",
  "hashtag.counter_by_uses": "{count, plural, one {הודעה אחת} two {הודעותיים} many {{counter} הודעות} other {{counter} הודעות}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {הודעה אחת} two {הודעותיים} many {{counter} הודעות} other {{counter} הודעות}} היום",
  "hashtag.feature": "מובלט בפרופיל",
  "hashtag.follow": "לעקוב אחרי תגית",
  "hashtag.mute": "להשתיק את #{hashtag}",
  "hashtag.unfeature": "לא להבליט בפרופיל",
  "hashtag.unfollow": "להפסיק לעקוב אחרי תגית",
  "hashtags.and_other": "…{count, plural,other {ועוד #}}",
  "hints.profiles.followers_may_be_missing": "יתכן כי עוקבים של פרופיל זה חסרים.",
  "hints.profiles.follows_may_be_missing": "יתכן כי נעקבים של פרופיל זה חסרים.",
  "hints.profiles.posts_may_be_missing": "יתכן כי פרסומים של פרופיל זה חסרים.",
  "hints.profiles.see_more_followers": "צפיה בעוד עוקבים משרת {domain}",
  "hints.profiles.see_more_follows": "צפיה בעוד נעקבים בשרת {domain}",
  "hints.profiles.see_more_posts": "צפיה בעוד פרסומים בשרת {domain}",
  "home.column_settings.show_quotes": "הצגת ציטוטים",
  "home.column_settings.show_reblogs": "הצגת הדהודים",
  "home.column_settings.show_replies": "הצגת תגובות",
  "home.hide_announcements": "הסתר הכרזות",
  "home.pending_critical_update.body": "יש לעדכן את תוכנת מסטודון בהקדם האפשרי!",
  "home.pending_critical_update.link": "צפיה בעדכונים",
  "home.pending_critical_update.title": "יצא עדכון אבטחה חשוב!",
  "home.show_announcements": "הצג הכרזות",
  "ignore_notifications_modal.bots_title": "להתעלם מהתראות מחשבונות רובוטיים?",
  "ignore_notifications_modal.disclaimer": "מסטודון אינו יכול ליידע משתמשים שהתעלמתם מהתראותיהם. התעלמות מהתראות לא תחסום את ההודעות עצמן מלהשלח.",
  "ignore_notifications_modal.filter_instead": "לסנן במקום",
  "ignore_notifications_modal.filter_to_act_users": "עדיין ביכולתך לקבל, לדחות ולדווח על משתמשים אחרים",
  "ignore_notifications_modal.filter_to_avoid_confusion": "סינון מסייע למניעת בלבולים אפשריים",
  "ignore_notifications_modal.filter_to_review_separately": "ניתן לסקור התראות מפולטרות בנפרד",
  "ignore_notifications_modal.ignore": "להתעלם מהתראות",
  "ignore_notifications_modal.limited_accounts_title": "להתעלם מהתראות מחשבונות תחת פיקוח דיון?",
  "ignore_notifications_modal.new_accounts_title": "להתעלם מהתראות מחשבונות חדשים?",
  "ignore_notifications_modal.not_followers_title": "להתעלם מהתראות מא.נשים שאינם עוקביך?",
  "ignore_notifications_modal.not_following_title": "להתעלם מהתראות מא.נשים שאינם נעקביך?",
  "ignore_notifications_modal.private_mentions_title": "להתעלם מהתראות מאיזכורים פרטיים?",
  "info_button.label": "עזרה",
  "info_button.what_is_alt_text": "<h1>מהו כיתוב חלופי?</h1> <p>כיתוב חלופי משמש תיאור מילולי של תמונות לסובלים ממגבלות ראיה, חיבורי רשת איטיים, או אלו הצריכים הקשר יותר מפורט לתוכן המולטימדיה המצורף.</p> <p>ניתן לשפר את הנגישות והבנת התוכן לכולם ע\"י כתיבת תיאור ברור, תמציתי ונטול פניות.</p> <ul> <li>כיסוי היסודות החשובים</li> <li>סיכום המלל שבתמונות</li> <li>שימוש במבנה משפטים רגיל</li> <li>יש להמנע מחזרה על מידע</li> <li>אם העזרים הויזואליים הם דיאגרמות או מפות, התמקדו במגמות וממצאים מרכזיים.</li> </ul>",
  "interaction_modal.action": "כדי להגיב להודעה של {name}, עליך להזהות בשם המשתמש שלך בשרת המסטודון בו את.ה משתמש.ת.",
  "interaction_modal.action_follow": "כדי לעקוב אחרי {name}, עליך להזהות בשם המשתמש שלך בשרת המסטודון בו את.ה משתמש.ת.",
  "interaction_modal.go": "המשך",
  "interaction_modal.no_account_yet": "אין לך עדיין חשבון?",
  "interaction_modal.on_another_server": "על שרת אחר",
  "interaction_modal.on_this_server": "על שרת זה",
  "interaction_modal.title": "יש להזדהות כדי להמשיך",
  "interaction_modal.username_prompt": "למשל {example}",
  "intervals.full.days": "{number, plural, one {יום} two {יומיים} other {# ימים}}",
  "intervals.full.hours": "{number, plural, one {# שעה} other {# שעות}}",
  "intervals.full.minutes": "{number, plural, one {# דקה} other {# דקות}}",
  "keyboard_shortcuts.back": "ניווט חזרה",
  "keyboard_shortcuts.blocked": "פתיחת רשימת חסומים",
  "keyboard_shortcuts.boost": "להדהד",
  "keyboard_shortcuts.column": "להתמקד בחצרוץ באחד מהטורים",
  "keyboard_shortcuts.compose": "להתמקד בתיבת חיבור החצרוצים",
  "keyboard_shortcuts.description": "תיאור",
  "keyboard_shortcuts.direct": "לפתוח עמודת שיחות פרטיות",
  "keyboard_shortcuts.down": "לנוע במורד הרשימה",
  "keyboard_shortcuts.enter": "פתח הודעה",
  "keyboard_shortcuts.explore": "הצגת קו הזמן של ההודעות החמות",
  "keyboard_shortcuts.favourite": "חיבוב הודעה",
  "keyboard_shortcuts.favourites": "פתיחת רשימת מחובבות",
  "keyboard_shortcuts.federated": "פתיחת ציר זמן בין-קהילתי",
  "keyboard_shortcuts.heading": "מקשי קיצור במקלדת",
  "keyboard_shortcuts.home": "פתיחת ציר זמן אישי",
  "keyboard_shortcuts.hotkey": "מקש קיצור",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "מחיקה אחורה",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Page Down",
  "keyboard_shortcuts.keys.page_up": "דיפדוף מעלה",
  "keyboard_shortcuts.legend": "הצגת מקרא",
  "keyboard_shortcuts.load_more": "התמקדות בכפתור \"טען עוד\"",
  "keyboard_shortcuts.local": "פתיחת ציר זמן קהילתי",
  "keyboard_shortcuts.mention": "לאזכר את המחבר.ת",
  "keyboard_shortcuts.muted": "פתיחת רשימת משתמשים מושתקים",
  "keyboard_shortcuts.my_profile": "פתיחת הפרופיל שלך",
  "keyboard_shortcuts.notifications": "פתיחת טור התראות",
  "keyboard_shortcuts.open_media": "פתיחת מדיה",
  "keyboard_shortcuts.pinned": "פתיחת הודעה נעוצות",
  "keyboard_shortcuts.profile": "פתח את פרופיל המשתמש",
  "keyboard_shortcuts.quote": "לצטט ההודעה",
  "keyboard_shortcuts.reply": "תגובה להודעה",
  "keyboard_shortcuts.requests": "פתיחת רשימת בקשות מעקב",
  "keyboard_shortcuts.search": "להתמקד בחלון החיפוש",
  "keyboard_shortcuts.spoilers": "הצגת/הסתרת שדה אזהרת תוכן (CW)",
  "keyboard_shortcuts.start": "לפתוח את הטור \"בואו נתחיל\"",
  "keyboard_shortcuts.toggle_hidden": "הצגת/הסתרת טקסט מוסתר מאחורי אזהרת תוכן",
  "keyboard_shortcuts.toggle_sensitivity": "הצגת/הסתרת מדיה",
  "keyboard_shortcuts.toot": "להתחיל חיצרוץ חדש",
  "keyboard_shortcuts.top": "העברה לראש הרשימה",
  "keyboard_shortcuts.translate": "לתרגם הודעה",
  "keyboard_shortcuts.unfocus": "לצאת מתיבת חיבור/חיפוש",
  "keyboard_shortcuts.up": "לנוע במעלה הרשימה",
  "learn_more_link.got_it": "הבנתי",
  "learn_more_link.learn_more": "למידע נוסף",
  "lightbox.close": "סגירה",
  "lightbox.next": "הבא",
  "lightbox.previous": "הקודם",
  "lightbox.zoom_in": "הגדלה לגודל מלא",
  "lightbox.zoom_out": "התאמה לגודל המסך",
  "limited_account_hint.action": "הצג חשבון בכל זאת",
  "limited_account_hint.title": "פרופיל המשתמש או השרת כולו הוסתר על ידי מנחי הדיון של {domain}.",
  "link_preview.author": "מאת {name}",
  "link_preview.more_from_author": "עוד מאת {name}",
  "link_preview.shares": "{count, plural, one {הודעה אחת} two {הודעותיים} many {{counter} הודעות} other {{counter} הודעות}}",
  "lists.add_member": "הוספה",
  "lists.add_to_list": "הוספה לרשימה",
  "lists.add_to_lists": "הוספת {name} לרשימות",
  "lists.create": "יצירה",
  "lists.create_a_list_to_organize": "יצירת רשימה חדשה לארגון פיד הבית שלך",
  "lists.create_list": "יצירת רשימה",
  "lists.delete": "מחיקת רשימה",
  "lists.done": "בוצע",
  "lists.edit": "עריכת רשימה",
  "lists.exclusive": "הסתרת החברים בפיד הבית",
  "lists.exclusive_hint": "אם שם כלשהו ברשימה זו, נסתיר אותי בפיד הבית כדי למנוע כפילות.",
  "lists.find_users_to_add": "חיפוש משתמשים להוספה",
  "lists.list_members_count": "{count, plural, one {חבר רשימה אחד} other {# חברי רשימה}}",
  "lists.list_name": "שם הרשימה",
  "lists.new_list_name": "שם רשימה חדשה",
  "lists.no_lists_yet": "אין רשימות עדיין.",
  "lists.no_members_yet": "עוד אין חברים ברשימה.",
  "lists.no_results_found": "לא נמצאו תוצאות.",
  "lists.remove_member": "הסרה",
  "lists.replies_policy.followed": "משתמשים שאני עוקב אחריהם",
  "lists.replies_policy.list": "משתמשים שברשימה",
  "lists.replies_policy.none": "אף אחד",
  "lists.save": "שמירה",
  "lists.search": "חיפוש",
  "lists.show_replies_to": "לכלול תשובות מחברי הרשימה אל",
  "load_pending": "{count, plural, one {# פריט חדש} other {# פריטים חדשים}}",
  "loading_indicator.label": "בטעינה…",
  "media_gallery.hide": "להסתיר",
  "moved_to_account_banner.text": "חשבונך {disabledAccount} אינו פעיל כרגע עקב מעבר ל{movedToAccount}.",
  "mute_modal.hide_from_notifications": "להסתיר מהתראות",
  "mute_modal.hide_options": "הסתרת אפשרויות",
  "mute_modal.indefinite": "עד שאסיר השתקה",
  "mute_modal.show_options": "הצגת אפשרויות",
  "mute_modal.they_can_mention_and_follow": "הם יכולם לאזכר אתכם ולעקוב אחריכם, אבל לא תראו אותם.",
  "mute_modal.they_wont_know": "הם לא ידעו כי הושתקו.",
  "mute_modal.title": "להשתיק משתמש?",
  "mute_modal.you_wont_see_mentions": "לא תראה הודעות שמאזכרות אותם.",
  "mute_modal.you_wont_see_posts": "הם יכולים לראות את הודעותכם, אבל אתם לא תוכלו לראות את שלהם.",
  "navigation_bar.about": "אודות",
  "navigation_bar.account_settings": "סיסמה ואבטחה",
  "navigation_bar.administration": "ניהול",
  "navigation_bar.advanced_interface": "פתח במנשק ווב מתקדם",
  "navigation_bar.automated_deletion": "מחיקת הודעות אוטומטית",
  "navigation_bar.blocks": "משתמשים חסומים",
  "navigation_bar.bookmarks": "סימניות",
  "navigation_bar.collections": "אוספים",
  "navigation_bar.direct": "הודעות פרטיות",
  "navigation_bar.domain_blocks": "קהילות (שמות מתחם) חסומות",
  "navigation_bar.favourites": "חיבובים",
  "navigation_bar.filters": "מילים מושתקות",
  "navigation_bar.follow_requests": "בקשות מעקב",
  "navigation_bar.followed_tags": "תגיות שהחשבון שלך עוקב אחריהן",
  "navigation_bar.follows_and_followers": "נעקבים ועוקבים",
  "navigation_bar.import_export": "יבוא ויצוא",
  "navigation_bar.lists": "רשימות",
  "navigation_bar.live_feed_local": "פיד ההודעות בזמן אמת (מקומי)",
  "navigation_bar.live_feed_public": "פיד ההודעות בזמן אמת (פומבי)",
  "navigation_bar.logout": "התנתקות",
  "navigation_bar.main": "ראשי",
  "navigation_bar.moderation": "הנחיית דיונים",
  "navigation_bar.more": "עוד",
  "navigation_bar.mutes": "משתמשים בהשתקה",
  "navigation_bar.opened_in_classic_interface": "הודעות, חשבונות ושאר עמודי רשת יפתחו כברירת מחדל בדפדפן רשת קלאסי.",
  "navigation_bar.preferences": "העדפות",
  "navigation_bar.privacy_and_reach": "פרטיות ומידת חשיפה",
  "navigation_bar.search": "חיפוש",
  "navigation_bar.search_trends": "חיפוש \\ מגמות",
  "navigation_panel.collapse_followed_tags": "קיפול תפריט תגיות במעקב",
  "navigation_panel.collapse_lists": "קיפול תפריט רשימות",
  "navigation_panel.expand_followed_tags": "פתיחת תפריט תגיות במעקב",
  "navigation_panel.expand_lists": "פתיחת תפריט רשימות",
  "not_signed_in_indicator.not_signed_in": "יש להיות מאומת כדי לגשת למשאב זה.",
  "notification.added_to_collection": "{name} הוסיפו אותך לאוסף",
  "notification.admin.report": "{name} דיווח.ה על {target}",
  "notification.admin.report_account": "{name} דווחו על {count, plural, one {הודעה אחת} two {הודעותיים} many {# הודעות} other {# הודעות}} מאת {target} בגין {category}",
  "notification.admin.report_account_other": "{name} דווחו על {count, plural, one {הודעה אחת} two {הודעותיים} many {# הודעות} other {# הודעות}} מאת {target}",
  "notification.admin.report_statuses": "{name} דווחו על {target} בגין {category}",
  "notification.admin.report_statuses_other": "{name} דיווח.ה על {target}",
  "notification.admin.sign_up": "{name} נרשמו",
  "notification.admin.sign_up.name_and_others": "{name} ועוד {count, plural,one {אחד אחר}other {# אחרים}} נרשמו",
  "notification.annual_report.message": "ה- #סיכומודון שלך לשנת {year} מחכה! גלו את רגעי השיא והזכרונות ממסטודון!",
  "notification.annual_report.view": "לצפייה ב- #סיכומודון",
  "notification.collection_update": "{name} ערכו אוסף הכולל אותך",
  "notification.favourite": "הודעתך חובבה על ידי {name}",
  "notification.favourite.name_and_others_with_link": "{name} ועוד <a>{count, plural,one {אחד נוסף}other {# נוספים}}</a> חיבבו את הודעתך",
  "notification.favourite_pm": "{name} חיבב.ה איזכור שלך בהודעה פרטית",
  "notification.favourite_pm.name_and_others_with_link": "{name} ועוד <a>{count, plural,one {אחד נוסף}other {# נוספים}}</a> חיבבו הודעתך הפרטית",
  "notification.follow": "{name} במעקב אחרייך",
  "notification.follow.name_and_others": "{name} ועוד <a>{count, plural,one {מישהו} other {# אחרים}}</a> החלו לעקוב אחריך",
  "notification.follow_request": "{name} ביקשו לעקוב אחריך",
  "notification.follow_request.name_and_others": "{name} ועוד {count, plural,one {אחד אחר}other {# אחרים}} ביקשו לעקוב אחריך",
  "notification.label.mention": "אזכור",
  "notification.label.private_mention": "אזכור פרטי",
  "notification.label.private_reply": "תשובה בפרטי",
  "notification.label.quote": "{name} ציטט.ה את הודעתך",
  "notification.label.reply": "תשובה",
  "notification.mention": "אזכור",
  "notification.mentioned_you": "אוזכרת על ידי {name}",
  "notification.moderation-warning.learn_more": "למידע נוסף",
  "notification.moderation_warning": "קיבלת אזהרה מצוות ניהול התוכן",
  "notification.moderation_warning.action_delete_statuses": "חלק מהודעותיך הוסרו.",
  "notification.moderation_warning.action_disable": "חשבונך הושבת.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "חלק מהודעותיך סומנו כרגישות.",
  "notification.moderation_warning.action_none": "חשבונך קיבל אזהרה מצוות ניהול התוכן.",
  "notification.moderation_warning.action_sensitive": "הודעותיך יסומנו כרגישות מעתה ואילך.",
  "notification.moderation_warning.action_silence": "חשבונך הוגבל.",
  "notification.moderation_warning.action_suspend": "חשבונך הושעה.",
  "notification.own_poll": "הסקר שלך הסתיים",
  "notification.poll": "סקר שהצבעת בו הסתיים",
  "notification.quoted_update": "{name} ערך הודעה שהשתמשת בה בציטוט",
  "notification.reblog": "הודעתך הודהדה על ידי {name}",
  "notification.reblog.name_and_others_with_link": "{name} ועוד <a>{count, plural,one {אחד נוסף}other {# נוספים}}</a> הדהדו את הודעתך",
  "notification.relationships_severance_event": "אבד הקשר עם {name}",
  "notification.relationships_severance_event.account_suspension": "מנהל.ת משרת {from} השע(ת)ה את {target}, ולפיכך לא תעודכנו יותר על ידם ולא תוכלו להיות איתם בקשר.",
  "notification.relationships_severance_event.domain_block": "מנהל.ת מאתר {from} חסמו את {target} ובכלל זה {followersCount} מעוקביך וגם {followingCount, plural, one {חשבון אחד} two {שני חשבונות} many {# חשבונות} other {# חשבונות}} מבין נעקביך.",
  "notification.relationships_severance_event.learn_more": "למידע נוסף",
  "notification.relationships_severance_event.user_domain_block": "חסמת את {target} ובכלל זה {followersCount} מעוקביך וגם {followingCount, plural, one {חשבון אחד} two {שני חשבונות} many {# חשבונות} other {# חשבונות}} מבין נעקביך.",
  "notification.status": "{name} הרגע פרסמו",
  "notification.update": "{name} ערכו הודעה",
  "notification_requests.accept": "לקבל",
  "notification_requests.accept_multiple": "{count, plural,one {לאשר קבלת בקשה…}other {לאשר קבלת # בקשות…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural,one {לאשר קבלת בקשה}other {לאשר קבלת בקשות}}",
  "notification_requests.confirm_accept_multiple.message": "אתם עומדים לאשר {count, plural,one {בקשת התראה אחת} other {# בקשות התראה}}. להמשיך?",
  "notification_requests.confirm_accept_multiple.title": "לקבל בקשות התראה?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural,one {לדחות בקשה}other {לדחות בקשות}} לקבלת התראה",
  "notification_requests.confirm_dismiss_multiple.message": "אתם עומדים לדחות {count, plural,one {בקשת התראה}other {# בקשות התראה}}. לא תוכלו למצוא {count, plural,one {אותה}other {אותן}} בקלות אחר כך. להמשיך?",
  "notification_requests.confirm_dismiss_multiple.title": "לדחות בקשות התראה?",
  "notification_requests.dismiss": "לבטל",
  "notification_requests.dismiss_multiple": "{count, plural,one {לדחות בקשה…}other {לדחות # בקשות…}}",
  "notification_requests.edit_selection": "עריכה",
  "notification_requests.exit_selection": "בוצע",
  "notification_requests.explainer_for_limited_account": "התראות על פעולות חשבון זה סוננו כי חשבון זה הוגבל על ידי מנהלי הדיונים.",
  "notification_requests.explainer_for_limited_remote_account": "התראות על פעולות חשבון זה סוננו כי חשבון זה או השרת שלו הוגבלו על ידי מנהלי הדיונים.",
  "notification_requests.maximize": "הגדלה למקסימום",
  "notification_requests.minimize_banner": "להקטין את כותרת ההודעות המסוננות",
  "notification_requests.notifications_from": "התראות מ־ {name}",
  "notification_requests.title": "התראות מסוננות",
  "notification_requests.view": "הצגת ההתראות",
  "notifications.clear": "הסרת התראות",
  "notifications.clear_confirmation": "להסיר את כל ההתראות לצמיתות ? ",
  "notifications.clear_title": "לנקות התראות?",
  "notifications.column_settings.admin.report": "דו\"חות חדשים",
  "notifications.column_settings.admin.sign_up": "הרשמות חדשות:",
  "notifications.column_settings.alert": "התראות לשולחן העבודה",
  "notifications.column_settings.collections": "אוספים:",
  "notifications.column_settings.favourite": "חיבובים:",
  "notifications.column_settings.filter_bar.advanced": "להציג את כל הקטגוריות",
  "notifications.column_settings.filter_bar.category": "שורת סינון מהיר",
  "notifications.column_settings.follow": "עוקבים חדשים:",
  "notifications.column_settings.follow_request": "בקשות מעקב חדשות:",
  "notifications.column_settings.group": "קבוצה",
  "notifications.column_settings.mention": "פניות:",
  "notifications.column_settings.poll": "תוצאות סקר:",
  "notifications.column_settings.push": "התראות בדחיפה",
  "notifications.column_settings.quote": "ציטוטים:",
  "notifications.column_settings.reblog": "הדהודים:",
  "notifications.column_settings.show": "הצגה בטור",
  "notifications.column_settings.sound": "שמע מופעל",
  "notifications.column_settings.status": "הודעות חדשות:",
  "notifications.column_settings.unread_notifications.category": "התראות שלא נקראו",
  "notifications.column_settings.unread_notifications.highlight": "הבלט התראות שלא נקראו",
  "notifications.column_settings.update": "שינויים:",
  "notifications.filter.all": "הכל",
  "notifications.filter.boosts": "הדהודים",
  "notifications.filter.collections": "אוספים",
  "notifications.filter.favourites": "חיבובים",
  "notifications.filter.follows": "נעקבים",
  "notifications.filter.mentions": "אזכורים",
  "notifications.filter.polls": "תוצאות סקר",
  "notifications.filter.statuses": "עדכונים מאנשים במעקב",
  "notifications.grant_permission": "מתן הרשאה.",
  "notifications.group": "{count} התראות",
  "notifications.mark_as_read": "סימון כל החצרוצים כנקראו",
  "notifications.permission_denied": "לא ניתן להציג התראות מסך כיוון כיוון שהרשאות דפדפן נשללו בעבר",
  "notifications.permission_denied_alert": "לא ניתן לאפשר נוטיפיקציות מסך שכן הדפדפן סורב הרשאה בעבר",
  "notifications.permission_required": "לא ניתן לאפשר נוטיפיקציות מסך כיוון שהרשאה דרושה לא ניתנה.",
  "notifications.policy.accept": "אישור",
  "notifications.policy.accept_hint": "הצגה בהתראות",
  "notifications.policy.drop": "להתעלם",
  "notifications.policy.drop_hint": "שליחה אל מצולות הנשיה, ולא יוודעו אודותיה לעולם",
  "notifications.policy.filter": "מסנן",
  "notifications.policy.filter_bots_hint": "חשבונות המסומנים כאוטומטיים",
  "notifications.policy.filter_bots_title": "בוטים",
  "notifications.policy.filter_hint": "שליחה לתיבה נכנסת מסוננת",
  "notifications.policy.filter_limited_accounts_hint": "הוגבל על ידי מנהלי הדיונים",
  "notifications.policy.filter_limited_accounts_title": "חשבומות תחת ניהול תוכן",
  "notifications.policy.filter_new_accounts.hint": "נוצר {days, plural,one {ביום האחרון} two {ביומיים האחרונים} other {ב־# הימים האחרונים}}",
  "notifications.policy.filter_new_accounts_title": "חשבונות חדשים",
  "notifications.policy.filter_not_followers_hint": "כולל משתמשים שעקבו אחריך פחות מ{days, plural,one {יום} two {יומיים} other {־# ימים}}",
  "notifications.policy.filter_not_followers_title": "משתמשים שלא עוקבות.ים אחריך",
  "notifications.policy.filter_not_following_hint": "עד שיאושרו ידנית על ידיך",
  "notifications.policy.filter_not_following_title": "משתמשים שאינך עוקב(ת) אחריהםן",
  "notifications.policy.filter_private_mentions_hint": "מסונן אלא אם זו תשובה למינשון שלך או אם אתם עוקבים אחרי העונה",
  "notifications.policy.filter_private_mentions_title": "מינשונים בפרטי שלא הוזמנו",
  "notifications.policy.title": "ניהול התראות מ…",
  "notifications_permission_banner.enable": "לאפשר נוטיפיקציות מסך",
  "notifications_permission_banner.how_to_control": "כדי לקבל התראות גם כאשר מסטודון סגור יש לאפשר התראות מסך. ניתן לשלוט בדיוק איזה סוג של אינטראקציות יביא להתראות מסך דרך כפתור ה- {icon} מרגע שהן מאופשרות.",
  "notifications_permission_banner.title": "לעולם אל תחמיץ דבר",
  "onboarding.follows.back": "בחזרה",
  "onboarding.follows.empty": "למצער, תוצאות לחיפושך אינן בנמצא. ניתן להשתמש בחיפוש או בדף החקירות לשם מציאת אנשים ולעקבם. אפשר גם לנסות שוב אחר כך.",
  "onboarding.follows.next": "להמשיך ליצירת הפרופיל שלך",
  "onboarding.follows.search": "חיפוש",
  "onboarding.follows.title": "כדי להתחיל, יש לעקוב אחרי אנשים",
  "onboarding.profile.discoverable": "כלול את הפרופיל שלי בעמודת התגליות",
  "onboarding.profile.discoverable_hint": "כשתבחרו להכלל ב\"תגליות\" על מסטודון, ההודעות שלכם עשויות להופיע בתוצאות חיפוש ועמודות \"נושאים חמים\", והפרופיל יוצע לאחרים עם תחומי עניין משותפים לכם.",
  "onboarding.profile.display_name": "שם להצגה",
  "onboarding.profile.display_name_hint": "שמך המלא או כינוי הכיף שלך…",
  "onboarding.profile.finish": "סיום",
  "onboarding.profile.note": "אודות",
  "onboarding.profile.note_hint": "ניתן @לאזכר משתמשים אחרים או #תגיות…",
  "onboarding.profile.title": "הגדרת פרופיל",
  "onboarding.profile.upload_avatar": "העלאת תמונת פרופיל",
  "onboarding.profile.upload_header": "העלאת כותרת פרופיל",
  "password_confirmation.exceeds_maxlength": "הסיסמה בשדה אימות הסיסמה ארוכה מאורך הסיסמה המירבי",
  "password_confirmation.mismatching": "אימות סיסמה אינו תואם לסיסמה",
  "picture_in_picture.restore": "החזירי למקומו",
  "poll.closed": "סגור",
  "poll.refresh": "רענון",
  "poll.reveal": "ראו תוצאות",
  "poll.total_people": "{count, plural, one {# איש/אישה} other {# אנשים}}",
  "poll.total_votes": "{count, plural, one {# קול} other {# קולות}}",
  "poll.vote": "הצבעה",
  "poll.voted": "הצבעת לתשובה זו",
  "poll.votes": "{votes, plural, one {# קול} other {# קולות}}",
  "poll_button.add_poll": "הוספת סקר",
  "poll_button.remove_poll": "הסרת סקר",
  "privacy.change": "שינוי פרטיות ההודעה",
  "privacy.direct.long": "כל המוזכרים בהודעה",
  "privacy.direct.short": "אזכור פרטי",
  "privacy.private.long": "לעוקביך בלבד",
  "privacy.private.short": "עוקבים",
  "privacy.public.long": "כל הגולשים, מחוברים למסטודון או לא",
  "privacy.public.short": "פומבי",
  "privacy.quote.anyone": "{visibility}, רשות הציטוט נתונה",
  "privacy.quote.disabled": "{visibility}, האפשרות לציטוט מכובה",
  "privacy.quote.limited": "{visibility}, האפשרות לציטוט מוגבלת",
  "privacy.unlisted.additional": "ההתנהגות דומה להודעה ציבורית, מלבד שההודעה לא תופיע בפיד החי המקומי או בתגיות, תגליות או חיפוש מסטודון, אפילו אם ביקשת שהחשבון כולו יהיה פומבי.",
  "privacy.unlisted.long": "מוסתרת מתוצאות חיפוש במסטודון, נושאים חמים וציר הזמן הציבורי",
  "privacy.unlisted.short": "ציבורי שקט",
  "privacy_policy.last_updated": "עודכן לאחרונה {date}",
  "privacy_policy.title": "מדיניות פרטיות",
  "quote_error.edit": "לא ניתן להוסיף ציטוטים בשלב עריכת ההודעה.",
  "quote_error.poll": "לא ניתן לכלול משאל כאשר מחברים הודעת ציטוט.",
  "quote_error.private_mentions": "ציטוט אינו אפשרי בהודעות פרטיות.",
  "quote_error.quote": "רק ציטוט אחד מותר בכל הודעה.",
  "quote_error.unauthorized": "אין לך הרשאה לצטט את ההודעה הזו.",
  "quote_error.upload": "ציטוט הכולל מדיה אינו אפשרי.",
  "recommended": "מומלץ",
  "refresh": "רענון",
  "regeneration_indicator.please_stand_by": "נא להמתין.",
  "regeneration_indicator.preparing_your_home_feed": "מכין לך את פיד הבית…",
  "relative_time.days": "{number} ימים",
  "relative_time.full.days": "לפני {number, plural, one {# יום} other {# ימים}}",
  "relative_time.full.hours": "לפני {number, plural, one {# שעה} other {# שעות}}",
  "relative_time.full.just_now": "ממש עכשיו",
  "relative_time.full.minutes": "לפני {number, plural, one {# דקה} other {# דקות}}",
  "relative_time.full.seconds": "לפני {number, plural, one {# שניה} other {# שניות}}",
  "relative_time.hours": "{number} שעות",
  "relative_time.just_now": "כרגע",
  "relative_time.minutes": "{number} דקות",
  "relative_time.seconds": "{number} שניות",
  "relative_time.today": "היום",
  "remove_quote_hint.button_label": "הבנתי",
  "remove_quote_hint.message": "ניתן לעשות זאת מתפריט האפשרויות {icon}",
  "remove_quote_hint.title": "להסיר את ההודעה המצוטטת?",
  "reply_indicator.attachments": "{count, plural,one {# קובץ מצורף}other {# קבצים מצורפים}}",
  "reply_indicator.cancel": "ביטול",
  "reply_indicator.poll": "משאל",
  "report.block": "לחסום",
  "report.block_explanation": "לא ניתן יהיה לראות את ההודעות שלהן. הן לא יוכלו לראות את ההודעות שלך או לעקוב אחריך. הם יוכלו לדעת שהם חסומים.",
  "report.categories.legal": "חוקי",
  "report.categories.other": "אחר",
  "report.categories.spam": "ספאם",
  "report.categories.violation": "התוכן מפר אחד או יותר מחוקי השרת",
  "report.category.subtitle": "בחר/י את המתאים ביותר",
  "report.category.title_account": "ספר/י לנו מה קורה עם הפרופיל הזה",
  "report.category.title_collection": "ספר/י לנו מה קורה עם האוסף הזה",
  "report.category.title_status": "ספר/י לנו מה קורה עם ההודעה הזו",
  "report.close": "בוצע",
  "report.comment.title": "האם יש דבר נוסף שלדעתך חשוב שנדע?",
  "report.forward": "קדם ל-{target}",
  "report.forward_hint": "חשבון זה הוא משרת אחר. האם לשלוח בנוסף עותק אנונימי לשם?",
  "report.mute": "להשתיק",
  "report.mute_explanation": "לא ניתן יהיה לראות את ההודעות. הם עדיין יוכלו לעקוב אחריך ולראות את ההודעות שלך ולא ידעו שהם מושתקים.",
  "report.next": "הבא",
  "report.placeholder": "הערות נוספות",
  "report.reasons.dislike": "אני לא אוהב את זה",
  "report.reasons.dislike_description": "זה לא משהו שתרצה/י לראות",
  "report.reasons.legal": "בלתי חוקי",
  "report.reasons.legal_description": "לדידך מתקיימת פה עבירה על חוקי מדינתך או מדינת השרת המארח",
  "report.reasons.other": "זה משהו אחר",
  "report.reasons.other_description": "הבעיה לא מתאימה לקטגוריות אחרות",
  "report.reasons.spam": "זה ספאם",
  "report.reasons.spam_description": "קישורים מרושעים, התייחסות מזוייפת או תגובות חוזרות",
  "report.reasons.violation": "מפר את חוקי השרת",
  "report.reasons.violation_description": "את/ה מודע/ת לכך שזה מפר חוקים ספציפיים",
  "report.rules.subtitle": "בחר/י את כל המתאימים",
  "report.rules.title": "אילו חוקים מופרים?",
  "report.statuses.subtitle": "בחר/י את כל המתאימים",
  "report.statuses.title": "האם ישנן הודעות התומכות בדיווח זה?",
  "report.submission_error": "לא ניתן לבצע את הדיווח",
  "report.submission_error_details": "נא לבדוק את חיבור הרשת ולנסות שוב מאוחר יותר.",
  "report.submit": "שליחה",
  "report.target": "דיווח על {target}",
  "report.thanks.take_action": "הנה כמה אפשרויות לשליטה בתצוגת מסטודון:",
  "report.thanks.take_action_actionable": "בזמן שאנו בוחנות את הדיווח, ניתן לפעול כנגד @{name}:",
  "report.thanks.title": "לא מעוניין/ת לראות את זה?",
  "report.thanks.title_actionable": "תודה על הדיווח, נבדוק את העניין.",
  "report.unfollow": "הפסיקו לעקוב אחרי @{name}",
  "report.unfollow_explanation": "אתם עוקבים אחרי החשבון הזה. כדי להפסיק לראות את הפרסומים שלו בפיד הבית שלכם, הפסיקו לעקוב אחריו.",
  "report_notification.attached_statuses": "{count, plural, one {הודעה מצורפת} two {הודעותיים מצורפות} many {{count} הודעות מצורפות} other {{count} הודעות מצורפות}}",
  "report_notification.categories.legal": "חוקי",
  "report_notification.categories.legal_sentence": "תוכן בלתי חוקי",
  "report_notification.categories.other": "שונות",
  "report_notification.categories.other_sentence": "אחר",
  "report_notification.categories.spam": "ספאם (דואר זבל)",
  "report_notification.categories.spam_sentence": "ספאם (דואר זבל)",
  "report_notification.categories.violation": "הפרת כלל",
  "report_notification.categories.violation_sentence": "הפרת כלל",
  "report_notification.open": "פתח דו\"ח",
  "search.clear": "ניקוי חיפוש",
  "search.no_recent_searches": "לא נמצאו חיפושים אחרונים",
  "search.placeholder": "חיפוש",
  "search.quick_action.account_search": "פרופילים המכילים {x}",
  "search.quick_action.go_to_account": "לצפיה בפרופיל {x}",
  "search.quick_action.go_to_hashtag": "לצפיה בתגית {x}",
  "search.quick_action.open_url": "לפתיחת {x} במסטודון",
  "search.quick_action.status_search": "הודעות המכילות {x}",
  "search.search_or_paste": "חפש או הזן קישור",
  "search_popout.full_text_search_disabled_message": "בלתי זמין על {domain}.",
  "search_popout.full_text_search_logged_out_message": "זמין רק לאחר כניסה לאתר.",
  "search_popout.language_code": "קוד ISO לשפה",
  "search_popout.options": "אפשרויות חיפוש",
  "search_popout.quick_actions": "פעולות זריזות",
  "search_popout.recent": "חיפושים אחרונים",
  "search_popout.specific_date": "תאריך מסוים",
  "search_popout.user": "משתמש(ת)",
  "search_results.accounts": "פרופילים",
  "search_results.all": "כל התוצאות",
  "search_results.collections": "אוספים",
  "search_results.hashtags": "תגיות",
  "search_results.no_results": "אין תוצאות.",
  "search_results.no_search_yet": "נסו לחפש אחר הודעות, פרופילי משתמשים או תגיות.",
  "search_results.see_all": "הראה הכל",
  "search_results.statuses": "הודעות",
  "search_results.title": "חיפוש אחר \"{q}\"",
  "server_banner.about_active_users": "משתמשים פעילים בשרת ב־30 הימים האחרונים (משתמשים פעילים חודשיים)",
  "server_banner.active_users": "משתמשים פעילים",
  "server_banner.administered_by": "מנוהל ע\"י:",
  "server_banner.is_one_of_many": "{domain} הוא שרת אחד משרתי מסטודון עצמאיים רבים שדרגם תוכלו להשתתף בפדיוורס (רשת חברתית מבוזרת).",
  "server_banner.more_about_this_server": "עוד אודות שרת זה",
  "server_banner.server_stats": "סטטיסטיקות שרת:",
  "sign_in_banner.create_account": "יצירת חשבון",
  "sign_in_banner.follow_anyone": "תוכלו לעקוב אחרי כל משמתמש בפדיוורס ולקרוא הכל לפי סדר הפרסום בציר הזמן. אין אלגוריתמים, פרסומות, או קליקבייט מטעם בעלי הרשת.",
  "sign_in_banner.mastodon_is": "מסטודון הוא הדרך הטובה ביותר לעקוב אחרי מה שקורה.",
  "sign_in_banner.sign_in": "התחברות",
  "sign_in_banner.sso_redirect": "התחברות/הרשמה",
  "skip_links.hotkey": "<span>מקש קיצור</span> {hotkey}",
  "skip_links.skip_to_content": "דלג לתוכן הראשי",
  "skip_links.skip_to_navigation": "דילוג לניווט המרכזי",
  "status.admin_account": "פתח/י ממשק פיקוח דיון עבור @{name}",
  "status.admin_domain": "פתיחת ממשק פיקוח דיון עבור {domain}",
  "status.admin_status": "לפתוח הודעה זו במסך ניהול הדיונים",
  "status.all_disabled": "הדהודים וציטוטים כובו",
  "status.block": "חסימת @{name}",
  "status.bookmark": "סימניה",
  "status.cancel_reblog_private": "הסרת הדהוד",
  "status.cannot_edit": "אין לך הרשאה לערוך הודעה הזו",
  "status.cannot_quote": "אין לך הרשאה לצטט את ההודעה הזו",
  "status.cannot_reblog": "לא ניתן להדהד חצרוץ זה",
  "status.contains_quote": "הודעה מכילה ציטוט",
  "status.context.loading": "נטענות תשובות נוספות",
  "status.context.loading_error": "טעינת תשובות נוספות נכשלה",
  "status.context.loading_success": "תשובות חדשות נטענו",
  "status.context.more_replies_found": "תשובות נוספות נמצאו",
  "status.context.retry": "נסה שוב",
  "status.context.show": "הצג",
  "status.continued_thread": "שרשור מתמשך",
  "status.copy": "העתק/י קישור להודעה זו",
  "status.delete": "מחיקה",
  "status.delete.success": "ההודעה נמחקה",
  "status.detailed_status": "תצוגת שיחה מפורטת",
  "status.direct": "הודעה פרטית אל @{name}",
  "status.direct_indicator": "הודעה פרטית",
  "status.edit": "עריכה",
  "status.edited": "נערך לאחרונה {date}",
  "status.edited_x_times": "נערך {count, plural, one {פעם {count}} other {{count} פעמים}}",
  "status.embed": "העתקת קוד להטמעה",
  "status.favourite": "חיבוב",
  "status.favourites_count": "{count, plural, one {חיבוב אחד} two {חיבוביים} many {{counter} חיבובים} other {{counter} חיבובים}}",
  "status.filter": "סנן הודעה זו",
  "status.history.created": "{name} יצר/ה {date}",
  "status.history.edited": "{name} ערך/ה {date}",
  "status.load_more": "טען עוד",
  "status.media.open": "לחץ לפתיחה",
  "status.media.show": "לחץ להצגה",
  "status.media_hidden": "מדיה מוסתרת",
  "status.mention": "פניה אל @{name}",
  "status.more": "עוד",
  "status.mute": "להשתיק את @{name}",
  "status.mute_conversation": "השתקת שיחה",
  "status.not_quoted": "אינך מצוטטת בהודעה זו",
  "status.open": "הרחבת הודעה זו",
  "status.pin": "הצמדה לפרופיל שלי",
  "status.public_only": "הודעה זו פרטית",
  "status.quote": "ציטוט",
  "status.quote.cancel": "ביטול הודעת ציטוט",
  "status.quote_error.blocked_account_hint.title": "ההודעה הזו מוסתרת כי חסמת את @{name}.",
  "status.quote_error.blocked_domain_hint.title": "ההודעה הזו מוסתרת כי חסמת את כל {domain}.",
  "status.quote_error.filtered": "מוסתר בהתאם לסננים שלך",
  "status.quote_error.limited_account_hint.action": "להציג בכל זאת",
  "status.quote_error.limited_account_hint.title": "חשבון הזה הוסתר על ידי מנחי הדיון של {domain}.",
  "status.quote_error.muted_account_hint.title": "ההודעה הזו מוסתרת כי השתקת את @{name}.",
  "status.quote_error.not_available": "ההודעה לא זמינה",
  "status.quote_error.pending_approval": "ההודעה בהמתנה לאישור",
  "status.quote_error.pending_approval_popout.body": "ברשת מסטודון, ניתן להגביל את האפשרות לצטט הודעות. ההודעה הזו ממתינה עד שהמחבר.ת של ההודעה המקורית יאשרו לך את הציטוט.",
  "status.quote_error.revoked": "ההודעה הוסרה על ידי המחבר.ת",
  "status.quote_followers_only": "רק עוקביך יוכלו לצטט את ההודעה",
  "status.quote_manual_review": "מחבר.ת ההודעה יחזרו אליך אחרי בדיקה",
  "status.quote_noun": "ציטוט",
  "status.quote_policy_change": "הגדרת הרשאה לציטוט הודעותיך",
  "status.quote_post_author": "ההודעה היא ציטוט של @{name}",
  "status.quote_private": "הודעות פרטיות לא ניתנות לציטוט",
  "status.quotes.empty": "עוד לא ציטטו את ההודעה הזו. כאשר זה יקרה, הציטוטים יופיעו כאן.",
  "status.quotes.local_other_disclaimer": "ציטוטים שיידחו על ידי המחברים המקוריים לא יוצגו.",
  "status.quotes.remote_other_disclaimer": "רק ציטוטים מהשרת {domain} מובטחים שיופיעו פה. ציטוטים שנדחו על ידי המצוטטים לא יופיעו.",
  "status.quotes_count": "{count, plural, one {ציטוט אחד} two {שני ציטוטים} many {{counter} ציטוטים} other {{counter} ציטוטים}}",
  "status.read_more": "לקרוא עוד",
  "status.reblog": "הדהוד",
  "status.reblog_or_quote": "להדהד או לצטט",
  "status.reblog_private": "שיתוף מחדש עם העוקבות והעוקבים שלך",
  "status.reblogged_by": "{name} הידהד/ה:",
  "status.reblogs.empty": "עוד לא הידהדו את ההודעה הזו. כאשר זה יקרה, ההדהודים יופיעו כאן.",
  "status.reblogs_count": "{count, plural, one {הידהוד אחד} two {שני הדהודים} many {{counter} הדהודים} other {{counter} הדהודים}}",
  "status.redraft": "מחיקה ועריכה מחדש",
  "status.remove_bookmark": "הסרת סימניה",
  "status.remove_favourite": "להסיר מרשימת המועדפים",
  "status.remove_quote": "הסרת ציטוט",
  "status.replied_in_thread": "תגובה לשרשור",
  "status.replied_to": "בתגובה לחשבון {name}",
  "status.reply": "תגובה",
  "status.replyAll": "תגובה לשרשור",
  "status.report": "דיווח על @{name}",
  "status.request_quote": "הגשת בקשה להרשות ציטוט",
  "status.revoke_quote": "הסירו את הודעתי מההודעה של @{name}",
  "status.sensitive_warning": "תוכן רגיש",
  "status.share": "שיתוף",
  "status.show_less_all": "להציג פחות מהכל",
  "status.show_more_all": "להציג יותר מהכל",
  "status.show_original": "הצגת מקור",
  "status.title.with_attachments": "{user} פרסם.ה {attachmentCount, plural, one {צרופה} other {{attachmentCount} צרופות}}",
  "status.translate": "לתרגם",
  "status.translated_from_with": "לתרגם משפה {lang} באמצעות {provider}",
  "status.uncached_media_warning": "תצוגה מקדימה אינה זמינה",
  "status.unmute_conversation": "הסרת השתקת שיחה",
  "status.unpin": "לשחרר מקיבוע באודות",
  "subscribed_languages.lead": "רק חצרוצים בשפות הנבחרות יופיעו בפיד הבית וברשימות שלך אחרי השינוי. נקו את כל הבחירות כדי לראות את כל השפות.",
  "subscribed_languages.save": "שמירת שינויים",
  "subscribed_languages.target": "שינוי רישום שפה עבור {target}",
  "tabs_bar.home": "פיד הבית",
  "tabs_bar.menu": "תפריט",
  "tabs_bar.notifications": "התראות",
  "tabs_bar.publish": "הודעה חדשה",
  "tabs_bar.quick_links": "קישורים מהירים",
  "tabs_bar.search": "חיפוש",
  "tag.remove": "הסרה",
  "terms_of_service.effective_as_of": "בתוקף החל מתאריך {date}",
  "terms_of_service.title": "תנאי השירות",
  "terms_of_service.upcoming_changes_on": "שינויים עתידיים שיחולו ביום {date}",
  "time_remaining.days": "נותרו {number, plural, one {יום} two {יומיים} other {# ימים}}",
  "time_remaining.hours": "נותרו {number, plural, one {# שעה} other {# שעות}}",
  "time_remaining.minutes": "נותרו {number, plural, one {# דקה} other {# דקות}}",
  "time_remaining.moments": "רגעים נותרו",
  "time_remaining.seconds": "נותרו {number, plural, one {# שניה} other {# שניות}}",
  "trends.counter_by_accounts": "{count, plural, one {אדם אחד} other {{counter} א.נשים}} {days, plural, one {מאז אתמול} two {ביומיים האחרונים} other {במשך {days} הימים האחרונים}}",
  "trends.trending_now": "נושאים חמים",
  "ui.beforeunload": "הטיוטא תאבד אם תעזבו את מסטודון.",
  "units.short.billion": "{count} מליארד",
  "units.short.million": "{count} מליון",
  "units.short.thousand": "{count} אלפים",
  "upload_area.title": "ניתן להעלות על ידי Drag & drop",
  "upload_button.label": "הוספת מדיה",
  "upload_error.limit": "קובץ להעלאה חורג מנפח מותר.",
  "upload_error.poll": "לא ניתן להעלות קובץ עם סקר.",
  "upload_error.quote": "לא ניתן להעלות קובץ כאשר מחברים הודעת ציטוט.",
  "upload_form.drag_and_drop.instructions": "כדי לבחור קובץ מוצמד, יש ללחוץ על מקש רווח או אנטר. בעת הגרירה, השתמשו במקשי החיצים כדי להזיז את הקובץ המוצמד בכל כיוון. לחצו רווח או אנטר בשנית כדי לעזוב את הקובץ במקומו החדש, או לחצו אסקייפ לביטול.",
  "upload_form.drag_and_drop.on_drag_cancel": "הגרירה בוטלה. קובץ המדיה {item} נעזב.",
  "upload_form.drag_and_drop.on_drag_end": "קובץ המדיה {item} נעזב.",
  "upload_form.drag_and_drop.on_drag_over": "קובץ המדיה {item} הוזז.",
  "upload_form.drag_and_drop.on_drag_start": "קובץ המדיה {item} נבחר.",
  "upload_form.edit": "עריכה",
  "upload_progress.label": "עולה...",
  "upload_progress.processing": "מעבד…",
  "username.taken": "שם המשתמש הזה תפוס. נסו אחר",
  "video.close": "סגירת וידאו",
  "video.download": "הורדת קובץ",
  "video.exit_fullscreen": "יציאה ממסך מלא",
  "video.expand": "להרחיב וידאו",
  "video.fullscreen": "מסך מלא",
  "video.hide": "להסתיר וידאו",
  "video.mute": "השתקה",
  "video.pause": "השהיה",
  "video.play": "ניגון",
  "video.skip_backward": "דילוג אחורה",
  "video.skip_forward": "דילוג קדימה",
  "video.unmute": "ביטול השתקה",
  "video.volume_down": "הנמכת עוצמת השמע",
  "video.volume_up": "הגברת עוצמת שמע",
  "visibility_modal.button_title": "בחירת רמת חשיפה",
  "visibility_modal.direct_quote_warning.text": "אם תשמרו את ההעדפות הנוכחיות, הציטוט המוטמע יהפוך לקישור.",
  "visibility_modal.direct_quote_warning.title": "לא ניתן להטמיע ציטוטים בהודעות פרטיות",
  "visibility_modal.header": "חשיפה והידוּד (אינטראקציה)",
  "visibility_modal.helper.direct_quoting": "איזכורים פרטיים שנוצרו במסטודון חסומים מציטוט על ידי אחרים.",
  "visibility_modal.helper.privacy_editing": "רמת החשיפה של ההודעה לא ניתנת לשינוי אחרי הפרסום.",
  "visibility_modal.helper.privacy_private_self_quote": "ציטוט עצמי של הודעות פרטיות בהודעה ציבורית איננו אפשרי.",
  "visibility_modal.helper.private_quoting": "הודעות לעוקבים־בלבד שנוצרו במסטודון חסומות מציטוט על ידי אחרים.",
  "visibility_modal.helper.unlisted_quoting": "כאשר אחרים מצטטים אותך, ההודעות שלהם יוסתרו גם מ\"נושאים חמים\".",
  "visibility_modal.instructions": "שליטה ביכולות השימוש של קהל הקוראות בהודעה. תוכלו גם לבחור את ברירות המחדל לכל ההודעות העתידיות על ידי ניווט אל <link>העדפות > ברירות מחדל בפרסום</link>.",
  "visibility_modal.privacy_label": "חשיפה",
  "visibility_modal.quote_followers": "לעוקבים בלבד",
  "visibility_modal.quote_label": "למי מותר לצטט",
  "visibility_modal.quote_nobody": "רק אני",
  "visibility_modal.quote_public": "כולם",
  "visibility_modal.save": "שמירה"
}
